import { cloneDeep } from "lodash-es";
import { useIQuerySdk } from "@dustess/iquery";
var CookieKeys = {
  Platform: {
    SID: "sid"
  }
};
var EventKeys = {
  WebSocket: "global-event-web-socket",
  UserAuth: "global-event-user-auth",
  PresentEvent: "global-event-present-event",
  PresentEventApp: "global-event-present-event-app",
  InitCoreSdk: "global-event-init-core-sdk",
  ShowLoading: "global-event-show-loading",
  HiddenLoading: "global-event-hide-loading",
  HiddenComponent: "global-event-hide-component",
  ReloadMicroPage: "global-event-reload-micro-page"
};
var DataKeys = {
  Menu: "global-data-menu",
  Access: "global-data-access",
  OEM: "global-data-oem",
  Components: "global-data-components",
  SwitchConfig: "global-data-switch-config",
  InitSdk: "global-data-init-sdk",
  TenantType: "global-data-tenant-type"
};
function dataBus() {
  var observerMap = /* @__PURE__ */ new Map();
  var sharedData = /* @__PURE__ */ new Map();
  function notNull(key) {
    return !!key;
  }
  function checkFunction(observer) {
    var isFunction = typeof observer === "function";
    if (!isFunction) {
      console.error("observer must be a function");
    }
    return isFunction;
  }
  function notify(dataKey, data) {
    if (!notNull(dataKey)) {
      return;
    }
    (observerMap.get(dataKey) || []).forEach(function(it) {
      return it(dataKey, data);
    });
  }
  function emitData(dataKey, data, notifyData) {
    if (notifyData === void 0) {
      notifyData = true;
    }
    if (!notNull(dataKey)) {
      return;
    }
    var newData = cloneDeep(data);
    sharedData.set(dataKey, newData);
    if (notifyData) {
      notify(dataKey, data);
    }
  }
  function getData(dataKey, clone) {
    if (clone === void 0) {
      clone = true;
    }
    if (clone) {
      return cloneDeep(sharedData.get(dataKey));
    }
    return sharedData.get(dataKey);
  }
  function on(dataKey, observer) {
    if (!checkFunction(observer) || !notNull(dataKey)) {
      return;
    }
    var list = observerMap.get(dataKey) || [];
    if (list.some(function(it) {
      return it === observer;
    })) {
      return;
    }
    list.push(observer);
    observerMap.set(dataKey, list);
  }
  function off(dataKey, observer) {
    if (!checkFunction(observer) || !notNull(dataKey)) {
      return;
    }
    var list = observerMap.get(dataKey) || [];
    if (!list.length) {
      return;
    }
    var index = list.findIndex(function(it) {
      return it === observer;
    });
    if (index !== -1) {
      list.splice(index, 1);
    }
  }
  function offData(dataKey) {
    if (!notNull(dataKey)) {
      return;
    }
    observerMap.delete(dataKey);
  }
  function once(dataKey, observer) {
    if (!checkFunction(observer) || !notNull(dataKey)) {
      return;
    }
    var onceFunc = function(dataKey2, data) {
      observer(dataKey2, data);
      off(dataKey2, onceFunc);
    };
    on(dataKey, onceFunc);
  }
  function log() {
    console.log("===data-bus:observerMap===", observerMap);
    console.log("===data-bus:sharedData===", sharedData);
  }
  return { on, off, offData, once, emitData, getData, log };
}
function useDataBus() {
  if (window.__ITIMO_DATA_SHARE) {
    return window.__ITIMO_DATA_SHARE;
  }
  window.__ITIMO_DATA_SHARE = dataBus();
  return window.__ITIMO_DATA_SHARE;
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
var _GlobalStateImp_unObserverList, _GlobalStateImp_dataBus;
var GlobalStateImp = function() {
  function GlobalStateImp2() {
    _GlobalStateImp_unObserverList.set(this, []);
    _GlobalStateImp_dataBus.set(this, useDataBus());
  }
  Object.defineProperty(GlobalStateImp2.prototype, "setGlobalState", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(dataKey, data, notifyObserver) {
      if (notifyObserver === void 0) {
        notifyObserver = true;
      }
      __classPrivateFieldGet(this, _GlobalStateImp_dataBus, "f").emitData(dataKey, data, notifyObserver);
    }
  });
  Object.defineProperty(GlobalStateImp2.prototype, "onGlobalState", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(dataKey, observer) {
      var _this = this;
      var callback = function(_key, data) {
        observer(data);
      };
      __classPrivateFieldGet(this, _GlobalStateImp_dataBus, "f").on(dataKey, callback);
      var destroy = function() {
        __classPrivateFieldGet(_this, _GlobalStateImp_dataBus, "f").off(dataKey, callback);
      };
      __classPrivateFieldGet(this, _GlobalStateImp_unObserverList, "f").push(destroy);
      return destroy;
    }
  });
  Object.defineProperty(GlobalStateImp2.prototype, "getGlobalState", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(dataKey) {
      return __classPrivateFieldGet(this, _GlobalStateImp_dataBus, "f").getData(dataKey, true);
    }
  });
  Object.defineProperty(GlobalStateImp2.prototype, "destroy", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      __classPrivateFieldGet(this, _GlobalStateImp_unObserverList, "f").forEach(function(u) {
        return u();
      });
      __classPrivateFieldSet(this, _GlobalStateImp_unObserverList, [], "f");
    }
  });
  Object.defineProperty(GlobalStateImp2.prototype, "log", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      console.log("global state======", __classPrivateFieldGet(this, _GlobalStateImp_unObserverList, "f"));
    }
  });
  return GlobalStateImp2;
}();
_GlobalStateImp_unObserverList = /* @__PURE__ */ new WeakMap(), _GlobalStateImp_dataBus = /* @__PURE__ */ new WeakMap();
var GlobalState = new GlobalStateImp();
function useEventBus() {
  function notNull(key) {
    return !!key;
  }
  function checkFunction(observer) {
    var isFunction = typeof observer === "function";
    if (!isFunction) {
      console.error("observer must be a function");
    }
    return isFunction;
  }
  function dispatch(event, detail) {
    if (detail === void 0) {
      detail = {};
    }
    if (!notNull(event)) {
      return;
    }
    window.dispatchEvent(new CustomEvent(event, { detail }));
  }
  function on(event, observer, options) {
    if (!checkFunction(observer) || !notNull(event)) {
      return;
    }
    window.addEventListener(event, observer, options);
  }
  function once(event, observer) {
    return on(event, observer, { once: true });
  }
  function off(event, observer, options) {
    if (!checkFunction(observer) || !notNull(event)) {
      return;
    }
    window.removeEventListener(event, observer, options);
  }
  return { on, off, once, dispatch };
}
var EventBus = useEventBus();
function getConfigEnv() {
  var _a2;
  return (_a2 = window.envConfig) === null || _a2 === void 0 ? void 0 : _a2.VUE_APP_MKCONFIG_ENV;
}
function getEnvWebGateWayHost() {
  var _a2;
  return (_a2 = window.envConfig) === null || _a2 === void 0 ? void 0 : _a2.VUE_APP_WEBGATEWAY_BASE_URL;
}
var webGatewayEnv = {
  dev: "dev",
  dev2: "dev2",
  dev3: "dev3",
  dev4: "dev4",
  master: "test",
  master2: "test2",
  master3: "test3",
  master4: "test4",
  qa: "qa",
  release: "",
  tencent: "tx"
};
var getWebGatewayHost = function() {
  var host = getEnvWebGateWayHost();
  if (host) {
    return host;
  }
  var config = getConfigEnv();
  if (!config)
    return void 0;
  var subDomain = "mk-api";
  var env = webGatewayEnv[config];
  switch (env) {
    case "":
      subDomain = "api";
      break;
    case "tx":
      subDomain = "api-".concat(env);
      break;
    default:
      subDomain = "".concat(subDomain, "-").concat(env);
  }
  return "https://".concat(subDomain, ".dustess.com");
};
var noop = function() {
};
function useAxiosNetwork(instance) {
  function factory2(method) {
    return function(url, params, extraParams) {
      var requestParams = __assign({ url, method }, extraParams);
      if (method === "GET") {
        requestParams.query = params;
      } else {
        requestParams.data = params;
      }
      return instance.ajax(requestParams);
    };
  }
  function webGateway(config) {
    var host = getWebGatewayHost();
    if (!host) {
      console.error("\u672A\u627E\u5230 webGateway \u8BF7\u6C42\u57DF\u540D");
      return;
    }
    var url = "".concat(host, "/webgateway/go");
    var _a22 = config.params, params = _a22 === void 0 ? {} : _a22, _b = config.extra, extra = _b === void 0 ? {} : _b, optionName = config.optionName;
    return instance.ajax({
      method: "POST",
      url,
      data: params,
      extra,
      header: { "option-name": optionName }
    });
  }
  var _a2 = [factory2("POST"), factory2("GET")], post2 = _a2[0], get = _a2[1];
  return {
    ajax: instance.ajax,
    check: instance.check || noop,
    post: post2,
    get,
    webGateway
  };
}
function getQueryString() {
  var query = {};
  var reg = /([^?=&]+)=([^?=&]+)/g;
  var match = location.href.match(reg);
  match === null || match === void 0 ? void 0 : match.forEach(function(it) {
    var _a2 = it.split("="), key = _a2[0], value = _a2[1];
    query[key] = value;
  });
  return query;
}
function reduceQueryParams(query) {
  if (!query)
    return "";
  return Object.entries(query).map(function(_a2) {
    var key = _a2[0], value = _a2[1];
    return "".concat(key, "=").concat(value);
  }).join("&");
}
function navigateTo(type, params) {
  var path = params.path, query = params.query;
  var origin = location.origin;
  var queryString = reduceQueryParams(query);
  var url = "".concat(origin).concat(path);
  if (queryString) {
    url += "?" + queryString;
  }
  if (type === "push") {
    location.href = url;
  } else {
    location.replace(url);
  }
}
function factory$2(type) {
  return function(params) {
    return navigateTo(type, params);
  };
}
var _a$1 = [factory$2("push"), factory$2("replace")], push$1 = _a$1[0], replace$1 = _a$1[1];
var RouterUtils = {
  push: push$1,
  replace: replace$1
};
function isInQianKun() {
  return window.__POWERED_BY_QIANKUN__;
}
function isDev() {
  return process.env["NODE_ENV"] === "development";
}
function useNextTask(task, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  setTimeout(function() {
    task();
  }, delay);
}
function isObject$2(data) {
  return Object.prototype.toString.apply(data) === "[object Object]";
}
/*! js-cookie v3.0.1 | MIT */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = key + "=" + converter.write(value, key) + stringifiedAttributes;
  }
  function get(key) {
    if (typeof document === "undefined" || arguments.length && !key) {
      return;
    }
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {
      }
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set,
    get,
    remove: function(key, attributes) {
      set(key, "", assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function(converter2) {
      return init(assign({}, this.converter, converter2), this.attributes);
    }
  }, {
    attributes: { value: Object.freeze(defaultAttributes) },
    converter: { value: Object.freeze(converter) }
  });
}
var api = init(defaultConverter, { path: "/" });
function getName(scope, name) {
  if (!scope) {
    return name;
  }
  return "".concat(scope, "-").concat(name);
}
function cookieFactory(scope) {
  var setCookie = function(name, value, options) {
    return api.set(getName(scope, name), value, options);
  };
  function getCookie(name) {
    return api.get(getName(scope, name));
  }
  var removeCookie = function(name, options) {
    return api.remove(getName(scope, name), options);
  };
  return {
    setCookie,
    getCookie,
    removeCookie
  };
}
var CookieStorage = cookieFactory("");
function localStorageFactory(scope) {
  function setItem(name, value) {
    var valueType = typeof value;
    if (valueType === "function" || valueType === "symbol") {
      console.error("LocalStorage.setItem value cannot be a function or a symbol");
      return false;
    }
    try {
      if (isObject$2(value)) {
        window.localStorage.setItem(getName(scope, name), JSON.stringify(value));
      } else {
        window.localStorage.setItem(getName(scope, name), value + "");
      }
      return true;
    } catch (error) {
      console.error(error);
    }
    return false;
  }
  function getItem(name) {
    var itemKey = getName(scope, name);
    return window.localStorage.getItem(itemKey);
  }
  function getJSONItem(name) {
    var itemKey = getName(scope, name);
    var value = window.localStorage.getItem(itemKey);
    if (!value)
      return void 0;
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error(error);
      return void 0;
    }
  }
  function removeItem(name) {
    window.localStorage.removeItem(getName(scope, name));
  }
  return {
    setItem,
    getItem,
    getJSONItem,
    removeItem
  };
}
var LegacyLocalStorage = localStorageFactory("");
function sessionFactory(scope) {
  function setSession(name, value) {
    window.sessionStorage.setItem(getName(scope, name), value);
  }
  function getSession(name) {
    return window.sessionStorage.getItem(getName(scope, name));
  }
  function removeSession(name) {
    window.sessionStorage.removeItem(getName(scope, name));
  }
  return {
    setSession,
    getSession,
    removeSession
  };
}
function createStorageFactory(scope) {
  return __assign(__assign(__assign({}, localStorageFactory(scope)), cookieFactory(scope)), sessionFactory(scope));
}
function factory$1(scope) {
  return createStorageFactory(scope);
}
var Storage = ["crm", "platform", "growth", "mall", "cs"].reduce(function(target, cur) {
  target[cur] = factory$1(cur);
  return target;
}, {});
var LocalStorageKeys = {
  Platform: {
    User: "user",
    Config: "config"
  }
};
function setUserSid(sid) {
  Storage.platform.setCookie(CookieKeys.Platform.SID, sid);
}
function getUserKey(platform) {
  return platform === "pc" ? "qw-user" : "user";
}
function getUserSid(platform) {
  var _a2;
  if (platform === void 0) {
    platform = "pc";
  }
  return platform === "pc" ? Storage.platform.getCookie(CookieKeys.Platform.SID) : Storage.platform.getCookie(CookieKeys.Platform.SID) || ((_a2 = LegacyLocalStorage.getJSONItem(getUserKey(platform))) === null || _a2 === void 0 ? void 0 : _a2.sid);
}
function setUser(user, platform) {
  if (platform === void 0) {
    platform = "pc";
  }
  if (!(user === null || user === void 0 ? void 0 : user.sid)) {
    return;
  }
  setUserSid(user.sid);
  Storage.platform.setItem(LocalStorageKeys.Platform.User, user);
  LegacyLocalStorage.setItem(getUserKey(platform), user);
}
function getUser(platform) {
  if (platform === void 0) {
    platform = "pc";
  }
  return Storage.platform.getJSONItem(LocalStorageKeys.Platform.User) || LegacyLocalStorage.getJSONItem(getUserKey(platform)) || {};
}
var SessionCookieKeys = [
  "dustess.aid",
  "dustess.cid",
  "dustess.uid",
  "dustess.sid"
];
function setLogout(platform, cleanCookie) {
  if (platform === void 0) {
    platform = "pc";
  }
  if (cleanCookie === void 0) {
    cleanCookie = true;
  }
  Storage.platform.removeItem(LocalStorageKeys.Platform.User);
  LegacyLocalStorage.removeItem(getUserKey(platform));
  Storage.platform.removeCookie(CookieKeys.Platform.SID);
  if (cleanCookie) {
    SessionCookieKeys.forEach(function(item) {
      return CookieStorage.removeCookie(item);
    });
  }
}
function setAgentConfig(config) {
  var corpId = config.corpId, corpid = config.corpid, agentId = config.agentId, isSideMenu = config.isSideMenu;
  if ((corpId || corpid) && agentId) {
    var configData = {
      corpId: corpId || corpid,
      agentId,
      isSideMenu
    };
    Storage.platform.setItem(LocalStorageKeys.Platform.Config, configData);
    LegacyLocalStorage.setItem(LocalStorageKeys.Platform.Config, configData);
  } else {
    console.error("set agent config error");
  }
}
function isValidConfig(config) {
  return (config === null || config === void 0 ? void 0 : config.corpId) && (config === null || config === void 0 ? void 0 : config.agentId);
}
function getAgentConfig(platform) {
  if (platform === void 0) {
    platform = "pc";
  }
  var queryParams = getQueryString();
  var config = platform === "pc" ? Storage.platform.getJSONItem(LocalStorageKeys.Platform.Config) : LegacyLocalStorage.getJSONItem(LocalStorageKeys.Platform.Config);
  return isValidConfig(queryParams) ? queryParams : config;
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var localforage = { exports: {} };
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(module, exports) {
  (function(f) {
    {
      module.exports = f();
    }
  })(function() {
    return function e(t, n, r) {
      function s(o2, u) {
        if (!n[o2]) {
          if (!t[o2]) {
            var a = typeof commonjsRequire == "function" && commonjsRequire;
            if (!u && a)
              return a(o2, true);
            if (i)
              return i(o2, true);
            var f = new Error("Cannot find module '" + o2 + "'");
            throw f.code = "MODULE_NOT_FOUND", f;
          }
          var l = n[o2] = { exports: {} };
          t[o2][0].call(l.exports, function(e2) {
            var n2 = t[o2][1][e2];
            return s(n2 ? n2 : e2);
          }, l, l.exports, e, t, n, r);
        }
        return n[o2].exports;
      }
      var i = typeof commonjsRequire == "function" && commonjsRequire;
      for (var o = 0; o < r.length; o++)
        s(r[o]);
      return s;
    }({ 1: [function(_dereq_, module2, exports2) {
      (function(global2) {
        var Mutation = global2.MutationObserver || global2.WebKitMutationObserver;
        var scheduleDrain;
        {
          if (Mutation) {
            var called = 0;
            var observer = new Mutation(nextTick);
            var element = global2.document.createTextNode("");
            observer.observe(element, {
              characterData: true
            });
            scheduleDrain = function() {
              element.data = called = ++called % 2;
            };
          } else if (!global2.setImmediate && typeof global2.MessageChannel !== "undefined") {
            var channel = new global2.MessageChannel();
            channel.port1.onmessage = nextTick;
            scheduleDrain = function() {
              channel.port2.postMessage(0);
            };
          } else if ("document" in global2 && "onreadystatechange" in global2.document.createElement("script")) {
            scheduleDrain = function() {
              var scriptEl = global2.document.createElement("script");
              scriptEl.onreadystatechange = function() {
                nextTick();
                scriptEl.onreadystatechange = null;
                scriptEl.parentNode.removeChild(scriptEl);
                scriptEl = null;
              };
              global2.document.documentElement.appendChild(scriptEl);
            };
          } else {
            scheduleDrain = function() {
              setTimeout(nextTick, 0);
            };
          }
        }
        var draining;
        var queue = [];
        function nextTick() {
          draining = true;
          var i, oldQueue;
          var len = queue.length;
          while (len) {
            oldQueue = queue;
            queue = [];
            i = -1;
            while (++i < len) {
              oldQueue[i]();
            }
            len = queue.length;
          }
          draining = false;
        }
        module2.exports = immediate;
        function immediate(task) {
          if (queue.push(task) === 1 && !draining) {
            scheduleDrain();
          }
        }
      }).call(this, typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {}], 2: [function(_dereq_, module2, exports2) {
      var immediate = _dereq_(1);
      function INTERNAL() {
      }
      var handlers = {};
      var REJECTED = ["REJECTED"];
      var FULFILLED = ["FULFILLED"];
      var PENDING = ["PENDING"];
      module2.exports = Promise2;
      function Promise2(resolver) {
        if (typeof resolver !== "function") {
          throw new TypeError("resolver must be a function");
        }
        this.state = PENDING;
        this.queue = [];
        this.outcome = void 0;
        if (resolver !== INTERNAL) {
          safelyResolveThenable(this, resolver);
        }
      }
      Promise2.prototype["catch"] = function(onRejected) {
        return this.then(null, onRejected);
      };
      Promise2.prototype.then = function(onFulfilled, onRejected) {
        if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) {
          return this;
        }
        var promise = new this.constructor(INTERNAL);
        if (this.state !== PENDING) {
          var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
          unwrap(promise, resolver, this.outcome);
        } else {
          this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
        }
        return promise;
      };
      function QueueItem(promise, onFulfilled, onRejected) {
        this.promise = promise;
        if (typeof onFulfilled === "function") {
          this.onFulfilled = onFulfilled;
          this.callFulfilled = this.otherCallFulfilled;
        }
        if (typeof onRejected === "function") {
          this.onRejected = onRejected;
          this.callRejected = this.otherCallRejected;
        }
      }
      QueueItem.prototype.callFulfilled = function(value) {
        handlers.resolve(this.promise, value);
      };
      QueueItem.prototype.otherCallFulfilled = function(value) {
        unwrap(this.promise, this.onFulfilled, value);
      };
      QueueItem.prototype.callRejected = function(value) {
        handlers.reject(this.promise, value);
      };
      QueueItem.prototype.otherCallRejected = function(value) {
        unwrap(this.promise, this.onRejected, value);
      };
      function unwrap(promise, func, value) {
        immediate(function() {
          var returnValue;
          try {
            returnValue = func(value);
          } catch (e) {
            return handlers.reject(promise, e);
          }
          if (returnValue === promise) {
            handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
          } else {
            handlers.resolve(promise, returnValue);
          }
        });
      }
      handlers.resolve = function(self2, value) {
        var result = tryCatch(getThen, value);
        if (result.status === "error") {
          return handlers.reject(self2, result.value);
        }
        var thenable = result.value;
        if (thenable) {
          safelyResolveThenable(self2, thenable);
        } else {
          self2.state = FULFILLED;
          self2.outcome = value;
          var i = -1;
          var len = self2.queue.length;
          while (++i < len) {
            self2.queue[i].callFulfilled(value);
          }
        }
        return self2;
      };
      handlers.reject = function(self2, error) {
        self2.state = REJECTED;
        self2.outcome = error;
        var i = -1;
        var len = self2.queue.length;
        while (++i < len) {
          self2.queue[i].callRejected(error);
        }
        return self2;
      };
      function getThen(obj) {
        var then = obj && obj.then;
        if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") {
          return function appyThen() {
            then.apply(obj, arguments);
          };
        }
      }
      function safelyResolveThenable(self2, thenable) {
        var called = false;
        function onError(value) {
          if (called) {
            return;
          }
          called = true;
          handlers.reject(self2, value);
        }
        function onSuccess(value) {
          if (called) {
            return;
          }
          called = true;
          handlers.resolve(self2, value);
        }
        function tryToUnwrap() {
          thenable(onSuccess, onError);
        }
        var result = tryCatch(tryToUnwrap);
        if (result.status === "error") {
          onError(result.value);
        }
      }
      function tryCatch(func, value) {
        var out = {};
        try {
          out.value = func(value);
          out.status = "success";
        } catch (e) {
          out.status = "error";
          out.value = e;
        }
        return out;
      }
      Promise2.resolve = resolve;
      function resolve(value) {
        if (value instanceof this) {
          return value;
        }
        return handlers.resolve(new this(INTERNAL), value);
      }
      Promise2.reject = reject;
      function reject(reason) {
        var promise = new this(INTERNAL);
        return handlers.reject(promise, reason);
      }
      Promise2.all = all;
      function all(iterable) {
        var self2 = this;
        if (Object.prototype.toString.call(iterable) !== "[object Array]") {
          return this.reject(new TypeError("must be an array"));
        }
        var len = iterable.length;
        var called = false;
        if (!len) {
          return this.resolve([]);
        }
        var values = new Array(len);
        var resolved = 0;
        var i = -1;
        var promise = new this(INTERNAL);
        while (++i < len) {
          allResolver(iterable[i], i);
        }
        return promise;
        function allResolver(value, i2) {
          self2.resolve(value).then(resolveFromAll, function(error) {
            if (!called) {
              called = true;
              handlers.reject(promise, error);
            }
          });
          function resolveFromAll(outValue) {
            values[i2] = outValue;
            if (++resolved === len && !called) {
              called = true;
              handlers.resolve(promise, values);
            }
          }
        }
      }
      Promise2.race = race;
      function race(iterable) {
        var self2 = this;
        if (Object.prototype.toString.call(iterable) !== "[object Array]") {
          return this.reject(new TypeError("must be an array"));
        }
        var len = iterable.length;
        var called = false;
        if (!len) {
          return this.resolve([]);
        }
        var i = -1;
        var promise = new this(INTERNAL);
        while (++i < len) {
          resolver(iterable[i]);
        }
        return promise;
        function resolver(value) {
          self2.resolve(value).then(function(response) {
            if (!called) {
              called = true;
              handlers.resolve(promise, response);
            }
          }, function(error) {
            if (!called) {
              called = true;
              handlers.reject(promise, error);
            }
          });
        }
      }
    }, { "1": 1 }], 3: [function(_dereq_, module2, exports2) {
      (function(global2) {
        if (typeof global2.Promise !== "function") {
          global2.Promise = _dereq_(2);
        }
      }).call(this, typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, { "2": 2 }], 4: [function(_dereq_, module2, exports2) {
      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
      } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function getIDB() {
        try {
          if (typeof indexedDB !== "undefined") {
            return indexedDB;
          }
          if (typeof webkitIndexedDB !== "undefined") {
            return webkitIndexedDB;
          }
          if (typeof mozIndexedDB !== "undefined") {
            return mozIndexedDB;
          }
          if (typeof OIndexedDB !== "undefined") {
            return OIndexedDB;
          }
          if (typeof msIndexedDB !== "undefined") {
            return msIndexedDB;
          }
        } catch (e) {
          return;
        }
      }
      var idb = getIDB();
      function isIndexedDBValid() {
        try {
          if (!idb || !idb.open) {
            return false;
          }
          var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
          var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
          return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && typeof IDBKeyRange !== "undefined";
        } catch (e) {
          return false;
        }
      }
      function createBlob(parts, properties) {
        parts = parts || [];
        properties = properties || {};
        try {
          return new Blob(parts, properties);
        } catch (e) {
          if (e.name !== "TypeError") {
            throw e;
          }
          var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
          var builder = new Builder();
          for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
          }
          return builder.getBlob(properties.type);
        }
      }
      if (typeof Promise === "undefined") {
        _dereq_(3);
      }
      var Promise$1 = Promise;
      function executeCallback(promise, callback) {
        if (callback) {
          promise.then(function(result) {
            callback(null, result);
          }, function(error) {
            callback(error);
          });
        }
      }
      function executeTwoCallbacks(promise, callback, errorCallback) {
        if (typeof callback === "function") {
          promise.then(callback);
        }
        if (typeof errorCallback === "function") {
          promise["catch"](errorCallback);
        }
      }
      function normalizeKey(key2) {
        if (typeof key2 !== "string") {
          console.warn(key2 + " used as a key, but it is not a string.");
          key2 = String(key2);
        }
        return key2;
      }
      function getCallback() {
        if (arguments.length && typeof arguments[arguments.length - 1] === "function") {
          return arguments[arguments.length - 1];
        }
      }
      var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
      var supportsBlobs = void 0;
      var dbContexts = {};
      var toString = Object.prototype.toString;
      var READ_ONLY = "readonly";
      var READ_WRITE = "readwrite";
      function _binStringToArrayBuffer(bin) {
        var length2 = bin.length;
        var buf = new ArrayBuffer(length2);
        var arr = new Uint8Array(buf);
        for (var i = 0; i < length2; i++) {
          arr[i] = bin.charCodeAt(i);
        }
        return buf;
      }
      function _checkBlobSupportWithoutCaching(idb2) {
        return new Promise$1(function(resolve) {
          var txn = idb2.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
          var blob = createBlob([""]);
          txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
          txn.onabort = function(e) {
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
          };
          txn.oncomplete = function() {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
          };
        })["catch"](function() {
          return false;
        });
      }
      function _checkBlobSupport(idb2) {
        if (typeof supportsBlobs === "boolean") {
          return Promise$1.resolve(supportsBlobs);
        }
        return _checkBlobSupportWithoutCaching(idb2).then(function(value) {
          supportsBlobs = value;
          return supportsBlobs;
        });
      }
      function _deferReadiness(dbInfo) {
        var dbContext = dbContexts[dbInfo.name];
        var deferredOperation = {};
        deferredOperation.promise = new Promise$1(function(resolve, reject) {
          deferredOperation.resolve = resolve;
          deferredOperation.reject = reject;
        });
        dbContext.deferredOperations.push(deferredOperation);
        if (!dbContext.dbReady) {
          dbContext.dbReady = deferredOperation.promise;
        } else {
          dbContext.dbReady = dbContext.dbReady.then(function() {
            return deferredOperation.promise;
          });
        }
      }
      function _advanceReadiness(dbInfo) {
        var dbContext = dbContexts[dbInfo.name];
        var deferredOperation = dbContext.deferredOperations.pop();
        if (deferredOperation) {
          deferredOperation.resolve();
          return deferredOperation.promise;
        }
      }
      function _rejectReadiness(dbInfo, err) {
        var dbContext = dbContexts[dbInfo.name];
        var deferredOperation = dbContext.deferredOperations.pop();
        if (deferredOperation) {
          deferredOperation.reject(err);
          return deferredOperation.promise;
        }
      }
      function _getConnection(dbInfo, upgradeNeeded) {
        return new Promise$1(function(resolve, reject) {
          dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
          if (dbInfo.db) {
            if (upgradeNeeded) {
              _deferReadiness(dbInfo);
              dbInfo.db.close();
            } else {
              return resolve(dbInfo.db);
            }
          }
          var dbArgs = [dbInfo.name];
          if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
          }
          var openreq = idb.open.apply(idb, dbArgs);
          if (upgradeNeeded) {
            openreq.onupgradeneeded = function(e) {
              var db = openreq.result;
              try {
                db.createObjectStore(dbInfo.storeName);
                if (e.oldVersion <= 1) {
                  db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                }
              } catch (ex) {
                if (ex.name === "ConstraintError") {
                  console.warn('The database "' + dbInfo.name + '" has been upgraded from version ' + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                } else {
                  throw ex;
                }
              }
            };
          }
          openreq.onerror = function(e) {
            e.preventDefault();
            reject(openreq.error);
          };
          openreq.onsuccess = function() {
            var db = openreq.result;
            db.onversionchange = function(e) {
              e.target.close();
            };
            resolve(db);
            _advanceReadiness(dbInfo);
          };
        });
      }
      function _getOriginalConnection(dbInfo) {
        return _getConnection(dbInfo, false);
      }
      function _getUpgradedConnection(dbInfo) {
        return _getConnection(dbInfo, true);
      }
      function _isUpgradeNeeded(dbInfo, defaultVersion) {
        if (!dbInfo.db) {
          return true;
        }
        var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
        var isDowngrade = dbInfo.version < dbInfo.db.version;
        var isUpgrade = dbInfo.version > dbInfo.db.version;
        if (isDowngrade) {
          if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + `" can't be downgraded from version ` + dbInfo.db.version + " to version " + dbInfo.version + ".");
          }
          dbInfo.version = dbInfo.db.version;
        }
        if (isUpgrade || isNewStore) {
          if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
              dbInfo.version = incVersion;
            }
          }
          return true;
        }
        return false;
      }
      function _encodeBlob(blob) {
        return new Promise$1(function(resolve, reject) {
          var reader = new FileReader();
          reader.onerror = reject;
          reader.onloadend = function(e) {
            var base64 = btoa(e.target.result || "");
            resolve({
              __local_forage_encoded_blob: true,
              data: base64,
              type: blob.type
            });
          };
          reader.readAsBinaryString(blob);
        });
      }
      function _decodeBlob(encodedBlob) {
        var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
        return createBlob([arrayBuff], { type: encodedBlob.type });
      }
      function _isEncodedBlob(value) {
        return value && value.__local_forage_encoded_blob;
      }
      function _fullyReady(callback) {
        var self2 = this;
        var promise = self2._initReady().then(function() {
          var dbContext = dbContexts[self2._dbInfo.name];
          if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
          }
        });
        executeTwoCallbacks(promise, callback, callback);
        return promise;
      }
      function _tryReconnect(dbInfo) {
        _deferReadiness(dbInfo);
        var dbContext = dbContexts[dbInfo.name];
        var forages = dbContext.forages;
        for (var i = 0; i < forages.length; i++) {
          var forage = forages[i];
          if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
          }
        }
        dbInfo.db = null;
        return _getOriginalConnection(dbInfo).then(function(db) {
          dbInfo.db = db;
          if (_isUpgradeNeeded(dbInfo)) {
            return _getUpgradedConnection(dbInfo);
          }
          return db;
        }).then(function(db) {
          dbInfo.db = dbContext.db = db;
          for (var i2 = 0; i2 < forages.length; i2++) {
            forages[i2]._dbInfo.db = db;
          }
        })["catch"](function(err) {
          _rejectReadiness(dbInfo, err);
          throw err;
        });
      }
      function createTransaction(dbInfo, mode, callback, retries) {
        if (retries === void 0) {
          retries = 1;
        }
        try {
          var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
          callback(null, tx);
        } catch (err) {
          if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) {
            return Promise$1.resolve().then(function() {
              if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                if (dbInfo.db) {
                  dbInfo.version = dbInfo.db.version + 1;
                }
                return _getUpgradedConnection(dbInfo);
              }
            }).then(function() {
              return _tryReconnect(dbInfo).then(function() {
                createTransaction(dbInfo, mode, callback, retries - 1);
              });
            })["catch"](callback);
          }
          callback(err);
        }
      }
      function createDbContext() {
        return {
          forages: [],
          db: null,
          dbReady: null,
          deferredOperations: []
        };
      }
      function _initStorage(options) {
        var self2 = this;
        var dbInfo = {
          db: null
        };
        if (options) {
          for (var i in options) {
            dbInfo[i] = options[i];
          }
        }
        var dbContext = dbContexts[dbInfo.name];
        if (!dbContext) {
          dbContext = createDbContext();
          dbContexts[dbInfo.name] = dbContext;
        }
        dbContext.forages.push(self2);
        if (!self2._initReady) {
          self2._initReady = self2.ready;
          self2.ready = _fullyReady;
        }
        var initPromises = [];
        function ignoreErrors() {
          return Promise$1.resolve();
        }
        for (var j = 0; j < dbContext.forages.length; j++) {
          var forage = dbContext.forages[j];
          if (forage !== self2) {
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
          }
        }
        var forages = dbContext.forages.slice(0);
        return Promise$1.all(initPromises).then(function() {
          dbInfo.db = dbContext.db;
          return _getOriginalConnection(dbInfo);
        }).then(function(db) {
          dbInfo.db = db;
          if (_isUpgradeNeeded(dbInfo, self2._defaultConfig.version)) {
            return _getUpgradedConnection(dbInfo);
          }
          return db;
        }).then(function(db) {
          dbInfo.db = dbContext.db = db;
          self2._dbInfo = dbInfo;
          for (var k = 0; k < forages.length; k++) {
            var forage2 = forages[k];
            if (forage2 !== self2) {
              forage2._dbInfo.db = dbInfo.db;
              forage2._dbInfo.version = dbInfo.version;
            }
          }
        });
      }
      function getItem(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store = transaction.objectStore(self2._dbInfo.storeName);
                var req = store.get(key2);
                req.onsuccess = function() {
                  var value = req.result;
                  if (value === void 0) {
                    value = null;
                  }
                  if (_isEncodedBlob(value)) {
                    value = _decodeBlob(value);
                  }
                  resolve(value);
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e) {
                reject(e);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function iterate(iterator, callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store = transaction.objectStore(self2._dbInfo.storeName);
                var req = store.openCursor();
                var iterationNumber = 1;
                req.onsuccess = function() {
                  var cursor = req.result;
                  if (cursor) {
                    var value = cursor.value;
                    if (_isEncodedBlob(value)) {
                      value = _decodeBlob(value);
                    }
                    var result = iterator(value, cursor.key, iterationNumber++);
                    if (result !== void 0) {
                      resolve(result);
                    } else {
                      cursor["continue"]();
                    }
                  } else {
                    resolve();
                  }
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e) {
                reject(e);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function setItem(key2, value, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          var dbInfo;
          self2.ready().then(function() {
            dbInfo = self2._dbInfo;
            if (toString.call(value) === "[object Blob]") {
              return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                if (blobSupport) {
                  return value;
                }
                return _encodeBlob(value);
              });
            }
            return value;
          }).then(function(value2) {
            createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store = transaction.objectStore(self2._dbInfo.storeName);
                if (value2 === null) {
                  value2 = void 0;
                }
                var req = store.put(value2, key2);
                transaction.oncomplete = function() {
                  if (value2 === void 0) {
                    value2 = null;
                  }
                  resolve(value2);
                };
                transaction.onabort = transaction.onerror = function() {
                  var err2 = req.error ? req.error : req.transaction.error;
                  reject(err2);
                };
              } catch (e) {
                reject(e);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function removeItem(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store = transaction.objectStore(self2._dbInfo.storeName);
                var req = store["delete"](key2);
                transaction.oncomplete = function() {
                  resolve();
                };
                transaction.onerror = function() {
                  reject(req.error);
                };
                transaction.onabort = function() {
                  var err2 = req.error ? req.error : req.transaction.error;
                  reject(err2);
                };
              } catch (e) {
                reject(e);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function clear(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store = transaction.objectStore(self2._dbInfo.storeName);
                var req = store.clear();
                transaction.oncomplete = function() {
                  resolve();
                };
                transaction.onabort = transaction.onerror = function() {
                  var err2 = req.error ? req.error : req.transaction.error;
                  reject(err2);
                };
              } catch (e) {
                reject(e);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function length(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store = transaction.objectStore(self2._dbInfo.storeName);
                var req = store.count();
                req.onsuccess = function() {
                  resolve(req.result);
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e) {
                reject(e);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function key(n, callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          if (n < 0) {
            resolve(null);
            return;
          }
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store = transaction.objectStore(self2._dbInfo.storeName);
                var advanced = false;
                var req = store.openKeyCursor();
                req.onsuccess = function() {
                  var cursor = req.result;
                  if (!cursor) {
                    resolve(null);
                    return;
                  }
                  if (n === 0) {
                    resolve(cursor.key);
                  } else {
                    if (!advanced) {
                      advanced = true;
                      cursor.advance(n);
                    } else {
                      resolve(cursor.key);
                    }
                  }
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e) {
                reject(e);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function keys(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store = transaction.objectStore(self2._dbInfo.storeName);
                var req = store.openKeyCursor();
                var keys2 = [];
                req.onsuccess = function() {
                  var cursor = req.result;
                  if (!cursor) {
                    resolve(keys2);
                    return;
                  }
                  keys2.push(cursor.key);
                  cursor["continue"]();
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e) {
                reject(e);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function dropInstance(options, callback) {
        callback = getCallback.apply(this, arguments);
        var currentConfig = this.config();
        options = typeof options !== "function" && options || {};
        if (!options.name) {
          options.name = options.name || currentConfig.name;
          options.storeName = options.storeName || currentConfig.storeName;
        }
        var self2 = this;
        var promise;
        if (!options.name) {
          promise = Promise$1.reject("Invalid arguments");
        } else {
          var isCurrentDb = options.name === currentConfig.name && self2._dbInfo.db;
          var dbPromise = isCurrentDb ? Promise$1.resolve(self2._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
              forages[i]._dbInfo.db = db;
            }
            return db;
          });
          if (!options.storeName) {
            promise = dbPromise.then(function(db) {
              _deferReadiness(options);
              var dbContext = dbContexts[options.name];
              var forages = dbContext.forages;
              db.close();
              for (var i = 0; i < forages.length; i++) {
                var forage = forages[i];
                forage._dbInfo.db = null;
              }
              var dropDBPromise = new Promise$1(function(resolve, reject) {
                var req = idb.deleteDatabase(options.name);
                req.onerror = function() {
                  var db2 = req.result;
                  if (db2) {
                    db2.close();
                  }
                  reject(req.error);
                };
                req.onblocked = function() {
                  console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                };
                req.onsuccess = function() {
                  var db2 = req.result;
                  if (db2) {
                    db2.close();
                  }
                  resolve(db2);
                };
              });
              return dropDBPromise.then(function(db2) {
                dbContext.db = db2;
                for (var i2 = 0; i2 < forages.length; i2++) {
                  var _forage = forages[i2];
                  _advanceReadiness(_forage._dbInfo);
                }
              })["catch"](function(err) {
                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                });
                throw err;
              });
            });
          } else {
            promise = dbPromise.then(function(db) {
              if (!db.objectStoreNames.contains(options.storeName)) {
                return;
              }
              var newVersion = db.version + 1;
              _deferReadiness(options);
              var dbContext = dbContexts[options.name];
              var forages = dbContext.forages;
              db.close();
              for (var i = 0; i < forages.length; i++) {
                var forage = forages[i];
                forage._dbInfo.db = null;
                forage._dbInfo.version = newVersion;
              }
              var dropObjectPromise = new Promise$1(function(resolve, reject) {
                var req = idb.open(options.name, newVersion);
                req.onerror = function(err) {
                  var db2 = req.result;
                  db2.close();
                  reject(err);
                };
                req.onupgradeneeded = function() {
                  var db2 = req.result;
                  db2.deleteObjectStore(options.storeName);
                };
                req.onsuccess = function() {
                  var db2 = req.result;
                  db2.close();
                  resolve(db2);
                };
              });
              return dropObjectPromise.then(function(db2) {
                dbContext.db = db2;
                for (var j = 0; j < forages.length; j++) {
                  var _forage2 = forages[j];
                  _forage2._dbInfo.db = db2;
                  _advanceReadiness(_forage2._dbInfo);
                }
              })["catch"](function(err) {
                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                });
                throw err;
              });
            });
          }
        }
        executeCallback(promise, callback);
        return promise;
      }
      var asyncStorage = {
        _driver: "asyncStorage",
        _initStorage,
        _support: isIndexedDBValid(),
        iterate,
        getItem,
        setItem,
        removeItem,
        clear,
        length,
        key,
        keys,
        dropInstance
      };
      function isWebSQLValid() {
        return typeof openDatabase === "function";
      }
      var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var BLOB_TYPE_PREFIX = "~~local_forage_type~";
      var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
      var SERIALIZED_MARKER = "__lfsc__:";
      var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
      var TYPE_ARRAYBUFFER = "arbf";
      var TYPE_BLOB = "blob";
      var TYPE_INT8ARRAY = "si08";
      var TYPE_UINT8ARRAY = "ui08";
      var TYPE_UINT8CLAMPEDARRAY = "uic8";
      var TYPE_INT16ARRAY = "si16";
      var TYPE_INT32ARRAY = "si32";
      var TYPE_UINT16ARRAY = "ur16";
      var TYPE_UINT32ARRAY = "ui32";
      var TYPE_FLOAT32ARRAY = "fl32";
      var TYPE_FLOAT64ARRAY = "fl64";
      var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
      var toString$1 = Object.prototype.toString;
      function stringToBuffer(serializedString) {
        var bufferLength = serializedString.length * 0.75;
        var len = serializedString.length;
        var i;
        var p = 0;
        var encoded1, encoded2, encoded3, encoded4;
        if (serializedString[serializedString.length - 1] === "=") {
          bufferLength--;
          if (serializedString[serializedString.length - 2] === "=") {
            bufferLength--;
          }
        }
        var buffer = new ArrayBuffer(bufferLength);
        var bytes = new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
          encoded1 = BASE_CHARS.indexOf(serializedString[i]);
          encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
          encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
          encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
          bytes[p++] = encoded1 << 2 | encoded2 >> 4;
          bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
          bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
      }
      function bufferToString(buffer) {
        var bytes = new Uint8Array(buffer);
        var base64String = "";
        var i;
        for (i = 0; i < bytes.length; i += 3) {
          base64String += BASE_CHARS[bytes[i] >> 2];
          base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
          base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
          base64String += BASE_CHARS[bytes[i + 2] & 63];
        }
        if (bytes.length % 3 === 2) {
          base64String = base64String.substring(0, base64String.length - 1) + "=";
        } else if (bytes.length % 3 === 1) {
          base64String = base64String.substring(0, base64String.length - 2) + "==";
        }
        return base64String;
      }
      function serialize(value, callback) {
        var valueType = "";
        if (value) {
          valueType = toString$1.call(value);
        }
        if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
          var buffer;
          var marker = SERIALIZED_MARKER;
          if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
          } else {
            buffer = value.buffer;
            if (valueType === "[object Int8Array]") {
              marker += TYPE_INT8ARRAY;
            } else if (valueType === "[object Uint8Array]") {
              marker += TYPE_UINT8ARRAY;
            } else if (valueType === "[object Uint8ClampedArray]") {
              marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === "[object Int16Array]") {
              marker += TYPE_INT16ARRAY;
            } else if (valueType === "[object Uint16Array]") {
              marker += TYPE_UINT16ARRAY;
            } else if (valueType === "[object Int32Array]") {
              marker += TYPE_INT32ARRAY;
            } else if (valueType === "[object Uint32Array]") {
              marker += TYPE_UINT32ARRAY;
            } else if (valueType === "[object Float32Array]") {
              marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === "[object Float64Array]") {
              marker += TYPE_FLOAT64ARRAY;
            } else {
              callback(new Error("Failed to get type for BinaryArray"));
            }
          }
          callback(marker + bufferToString(buffer));
        } else if (valueType === "[object Blob]") {
          var fileReader = new FileReader();
          fileReader.onload = function() {
            var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
          };
          fileReader.readAsArrayBuffer(value);
        } else {
          try {
            callback(JSON.stringify(value));
          } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);
            callback(null, e);
          }
        }
      }
      function deserialize(value) {
        if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
          return JSON.parse(value);
        }
        var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
        var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
        var blobType;
        if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
          var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
          blobType = matcher[1];
          serializedString = serializedString.substring(matcher[0].length);
        }
        var buffer = stringToBuffer(serializedString);
        switch (type) {
          case TYPE_ARRAYBUFFER:
            return buffer;
          case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
          case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
          case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
          case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
          case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
          case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
          case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
          case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
          case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
          case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
          default:
            throw new Error("Unkown type: " + type);
        }
      }
      var localforageSerializer = {
        serialize,
        deserialize,
        stringToBuffer,
        bufferToString
      };
      function createDbTable(t, dbInfo, callback, errorCallback) {
        t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
      }
      function _initStorage$1(options) {
        var self2 = this;
        var dbInfo = {
          db: null
        };
        if (options) {
          for (var i in options) {
            dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
          }
        }
        var dbInfoPromise = new Promise$1(function(resolve, reject) {
          try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
          } catch (e) {
            return reject(e);
          }
          dbInfo.db.transaction(function(t) {
            createDbTable(t, dbInfo, function() {
              self2._dbInfo = dbInfo;
              resolve();
            }, function(t2, error) {
              reject(error);
            });
          }, reject);
        });
        dbInfo.serializer = localforageSerializer;
        return dbInfoPromise;
      }
      function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
        t.executeSql(sqlStatement, args, callback, function(t2, error) {
          if (error.code === error.SYNTAX_ERR) {
            t2.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [dbInfo.storeName], function(t3, results) {
              if (!results.rows.length) {
                createDbTable(t3, dbInfo, function() {
                  t3.executeSql(sqlStatement, args, callback, errorCallback);
                }, errorCallback);
              } else {
                errorCallback(t3, error);
              }
            }, errorCallback);
          } else {
            errorCallback(t2, error);
          }
        }, errorCallback);
      }
      function getItem$1(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [key2], function(t2, results) {
                var result = results.rows.length ? results.rows.item(0).value : null;
                if (result) {
                  result = dbInfo.serializer.deserialize(result);
                }
                resolve(result);
              }, function(t2, error) {
                reject(error);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function iterate$1(iterator, callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t2, results) {
                var rows = results.rows;
                var length2 = rows.length;
                for (var i = 0; i < length2; i++) {
                  var item = rows.item(i);
                  var result = item.value;
                  if (result) {
                    result = dbInfo.serializer.deserialize(result);
                  }
                  result = iterator(result, item.key, i + 1);
                  if (result !== void 0) {
                    resolve(result);
                    return;
                  }
                }
                resolve();
              }, function(t2, error) {
                reject(error);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function _setItem(key2, value, callback, retriesLeft) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            if (value === void 0) {
              value = null;
            }
            var originalValue = value;
            var dbInfo = self2._dbInfo;
            dbInfo.serializer.serialize(value, function(value2, error) {
              if (error) {
                reject(error);
              } else {
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " (key, value) VALUES (?, ?)", [key2, value2], function() {
                    resolve(originalValue);
                  }, function(t2, error2) {
                    reject(error2);
                  });
                }, function(sqlError) {
                  if (sqlError.code === sqlError.QUOTA_ERR) {
                    if (retriesLeft > 0) {
                      resolve(_setItem.apply(self2, [key2, originalValue, callback, retriesLeft - 1]));
                      return;
                    }
                    reject(sqlError);
                  }
                });
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function setItem$1(key2, value, callback) {
        return _setItem.apply(this, [key2, value, callback, 1]);
      }
      function removeItem$1(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [key2], function() {
                resolve();
              }, function(t2, error) {
                reject(error);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function clear$1(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                resolve();
              }, function(t2, error) {
                reject(error);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function length$1(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t2, results) {
                var result = results.rows.item(0).c;
                resolve(result);
              }, function(t2, error) {
                reject(error);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function key$1(n, callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [n + 1], function(t2, results) {
                var result = results.rows.length ? results.rows.item(0).key : null;
                resolve(result);
              }, function(t2, error) {
                reject(error);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function keys$1(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t2, results) {
                var keys2 = [];
                for (var i = 0; i < results.rows.length; i++) {
                  keys2.push(results.rows.item(i).key);
                }
                resolve(keys2);
              }, function(t2, error) {
                reject(error);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function getAllStoreNames(db) {
        return new Promise$1(function(resolve, reject) {
          db.transaction(function(t) {
            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t2, results) {
              var storeNames = [];
              for (var i = 0; i < results.rows.length; i++) {
                storeNames.push(results.rows.item(i).name);
              }
              resolve({
                db,
                storeNames
              });
            }, function(t2, error) {
              reject(error);
            });
          }, function(sqlError) {
            reject(sqlError);
          });
        });
      }
      function dropInstance$1(options, callback) {
        callback = getCallback.apply(this, arguments);
        var currentConfig = this.config();
        options = typeof options !== "function" && options || {};
        if (!options.name) {
          options.name = options.name || currentConfig.name;
          options.storeName = options.storeName || currentConfig.storeName;
        }
        var self2 = this;
        var promise;
        if (!options.name) {
          promise = Promise$1.reject("Invalid arguments");
        } else {
          promise = new Promise$1(function(resolve) {
            var db;
            if (options.name === currentConfig.name) {
              db = self2._dbInfo.db;
            } else {
              db = openDatabase(options.name, "", "", 0);
            }
            if (!options.storeName) {
              resolve(getAllStoreNames(db));
            } else {
              resolve({
                db,
                storeNames: [options.storeName]
              });
            }
          }).then(function(operationInfo) {
            return new Promise$1(function(resolve, reject) {
              operationInfo.db.transaction(function(t) {
                function dropTable(storeName) {
                  return new Promise$1(function(resolve2, reject2) {
                    t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                      resolve2();
                    }, function(t2, error) {
                      reject2(error);
                    });
                  });
                }
                var operations = [];
                for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                  operations.push(dropTable(operationInfo.storeNames[i]));
                }
                Promise$1.all(operations).then(function() {
                  resolve();
                })["catch"](function(e) {
                  reject(e);
                });
              }, function(sqlError) {
                reject(sqlError);
              });
            });
          });
        }
        executeCallback(promise, callback);
        return promise;
      }
      var webSQLStorage = {
        _driver: "webSQLStorage",
        _initStorage: _initStorage$1,
        _support: isWebSQLValid(),
        iterate: iterate$1,
        getItem: getItem$1,
        setItem: setItem$1,
        removeItem: removeItem$1,
        clear: clear$1,
        length: length$1,
        key: key$1,
        keys: keys$1,
        dropInstance: dropInstance$1
      };
      function isLocalStorageValid() {
        try {
          return typeof localStorage !== "undefined" && "setItem" in localStorage && !!localStorage.setItem;
        } catch (e) {
          return false;
        }
      }
      function _getKeyPrefix(options, defaultConfig) {
        var keyPrefix = options.name + "/";
        if (options.storeName !== defaultConfig.storeName) {
          keyPrefix += options.storeName + "/";
        }
        return keyPrefix;
      }
      function checkIfLocalStorageThrows() {
        var localStorageTestKey = "_localforage_support_test";
        try {
          localStorage.setItem(localStorageTestKey, true);
          localStorage.removeItem(localStorageTestKey);
          return false;
        } catch (e) {
          return true;
        }
      }
      function _isLocalStorageUsable() {
        return !checkIfLocalStorageThrows() || localStorage.length > 0;
      }
      function _initStorage$2(options) {
        var self2 = this;
        var dbInfo = {};
        if (options) {
          for (var i in options) {
            dbInfo[i] = options[i];
          }
        }
        dbInfo.keyPrefix = _getKeyPrefix(options, self2._defaultConfig);
        if (!_isLocalStorageUsable()) {
          return Promise$1.reject();
        }
        self2._dbInfo = dbInfo;
        dbInfo.serializer = localforageSerializer;
        return Promise$1.resolve();
      }
      function clear$2(callback) {
        var self2 = this;
        var promise = self2.ready().then(function() {
          var keyPrefix = self2._dbInfo.keyPrefix;
          for (var i = localStorage.length - 1; i >= 0; i--) {
            var key2 = localStorage.key(i);
            if (key2.indexOf(keyPrefix) === 0) {
              localStorage.removeItem(key2);
            }
          }
        });
        executeCallback(promise, callback);
        return promise;
      }
      function getItem$2(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          var result = localStorage.getItem(dbInfo.keyPrefix + key2);
          if (result) {
            result = dbInfo.serializer.deserialize(result);
          }
          return result;
        });
        executeCallback(promise, callback);
        return promise;
      }
      function iterate$2(iterator, callback) {
        var self2 = this;
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          var keyPrefix = dbInfo.keyPrefix;
          var keyPrefixLength = keyPrefix.length;
          var length2 = localStorage.length;
          var iterationNumber = 1;
          for (var i = 0; i < length2; i++) {
            var key2 = localStorage.key(i);
            if (key2.indexOf(keyPrefix) !== 0) {
              continue;
            }
            var value = localStorage.getItem(key2);
            if (value) {
              value = dbInfo.serializer.deserialize(value);
            }
            value = iterator(value, key2.substring(keyPrefixLength), iterationNumber++);
            if (value !== void 0) {
              return value;
            }
          }
        });
        executeCallback(promise, callback);
        return promise;
      }
      function key$2(n, callback) {
        var self2 = this;
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          var result;
          try {
            result = localStorage.key(n);
          } catch (error) {
            result = null;
          }
          if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
          }
          return result;
        });
        executeCallback(promise, callback);
        return promise;
      }
      function keys$2(callback) {
        var self2 = this;
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          var length2 = localStorage.length;
          var keys2 = [];
          for (var i = 0; i < length2; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
              keys2.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
          }
          return keys2;
        });
        executeCallback(promise, callback);
        return promise;
      }
      function length$2(callback) {
        var self2 = this;
        var promise = self2.keys().then(function(keys2) {
          return keys2.length;
        });
        executeCallback(promise, callback);
        return promise;
      }
      function removeItem$2(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          localStorage.removeItem(dbInfo.keyPrefix + key2);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function setItem$2(key2, value, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = self2.ready().then(function() {
          if (value === void 0) {
            value = null;
          }
          var originalValue = value;
          return new Promise$1(function(resolve, reject) {
            var dbInfo = self2._dbInfo;
            dbInfo.serializer.serialize(value, function(value2, error) {
              if (error) {
                reject(error);
              } else {
                try {
                  localStorage.setItem(dbInfo.keyPrefix + key2, value2);
                  resolve(originalValue);
                } catch (e) {
                  if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
                    reject(e);
                  }
                  reject(e);
                }
              }
            });
          });
        });
        executeCallback(promise, callback);
        return promise;
      }
      function dropInstance$2(options, callback) {
        callback = getCallback.apply(this, arguments);
        options = typeof options !== "function" && options || {};
        if (!options.name) {
          var currentConfig = this.config();
          options.name = options.name || currentConfig.name;
          options.storeName = options.storeName || currentConfig.storeName;
        }
        var self2 = this;
        var promise;
        if (!options.name) {
          promise = Promise$1.reject("Invalid arguments");
        } else {
          promise = new Promise$1(function(resolve) {
            if (!options.storeName) {
              resolve(options.name + "/");
            } else {
              resolve(_getKeyPrefix(options, self2._defaultConfig));
            }
          }).then(function(keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
              var key2 = localStorage.key(i);
              if (key2.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key2);
              }
            }
          });
        }
        executeCallback(promise, callback);
        return promise;
      }
      var localStorageWrapper = {
        _driver: "localStorageWrapper",
        _initStorage: _initStorage$2,
        _support: isLocalStorageValid(),
        iterate: iterate$2,
        getItem: getItem$2,
        setItem: setItem$2,
        removeItem: removeItem$2,
        clear: clear$2,
        length: length$2,
        key: key$2,
        keys: keys$2,
        dropInstance: dropInstance$2
      };
      var sameValue = function sameValue2(x, y) {
        return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
      };
      var includes = function includes2(array, searchElement) {
        var len = array.length;
        var i = 0;
        while (i < len) {
          if (sameValue(array[i], searchElement)) {
            return true;
          }
          i++;
        }
        return false;
      };
      var isArray = Array.isArray || function(arg) {
        return Object.prototype.toString.call(arg) === "[object Array]";
      };
      var DefinedDrivers = {};
      var DriverSupport = {};
      var DefaultDrivers = {
        INDEXEDDB: asyncStorage,
        WEBSQL: webSQLStorage,
        LOCALSTORAGE: localStorageWrapper
      };
      var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];
      var OptionalDriverMethods = ["dropInstance"];
      var LibraryMethods = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(OptionalDriverMethods);
      var DefaultConfig = {
        description: "",
        driver: DefaultDriverOrder.slice(),
        name: "localforage",
        size: 4980736,
        storeName: "keyvaluepairs",
        version: 1
      };
      function callWhenReady(localForageInstance, libraryMethod) {
        localForageInstance[libraryMethod] = function() {
          var _args = arguments;
          return localForageInstance.ready().then(function() {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
          });
        };
      }
      function extend() {
        for (var i = 1; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            for (var _key in arg) {
              if (arg.hasOwnProperty(_key)) {
                if (isArray(arg[_key])) {
                  arguments[0][_key] = arg[_key].slice();
                } else {
                  arguments[0][_key] = arg[_key];
                }
              }
            }
          }
        }
        return arguments[0];
      }
      var LocalForage2 = function() {
        function LocalForage3(options) {
          _classCallCheck(this, LocalForage3);
          for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
              var driver = DefaultDrivers[driverTypeKey];
              var driverName = driver._driver;
              this[driverTypeKey] = driverName;
              if (!DefinedDrivers[driverName]) {
                this.defineDriver(driver);
              }
            }
          }
          this._defaultConfig = extend({}, DefaultConfig);
          this._config = extend({}, this._defaultConfig, options);
          this._driverSet = null;
          this._initDriver = null;
          this._ready = false;
          this._dbInfo = null;
          this._wrapLibraryMethodsWithReady();
          this.setDriver(this._config.driver)["catch"](function() {
          });
        }
        LocalForage3.prototype.config = function config(options) {
          if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
            if (this._ready) {
              return new Error("Can't call config() after localforage has been used.");
            }
            for (var i in options) {
              if (i === "storeName") {
                options[i] = options[i].replace(/\W/g, "_");
              }
              if (i === "version" && typeof options[i] !== "number") {
                return new Error("Database version must be a number.");
              }
              this._config[i] = options[i];
            }
            if ("driver" in options && options.driver) {
              return this.setDriver(this._config.driver);
            }
            return true;
          } else if (typeof options === "string") {
            return this._config[options];
          } else {
            return this._config;
          }
        };
        LocalForage3.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
          var promise = new Promise$1(function(resolve, reject) {
            try {
              var driverName = driverObject._driver;
              var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
              if (!driverObject._driver) {
                reject(complianceError);
                return;
              }
              var driverMethods = LibraryMethods.concat("_initStorage");
              for (var i = 0, len = driverMethods.length; i < len; i++) {
                var driverMethodName = driverMethods[i];
                var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                  reject(complianceError);
                  return;
                }
              }
              var configureMissingMethods = function configureMissingMethods2() {
                var methodNotImplementedFactory = function methodNotImplementedFactory2(methodName) {
                  return function() {
                    var error = new Error("Method " + methodName + " is not implemented by the current driver");
                    var promise2 = Promise$1.reject(error);
                    executeCallback(promise2, arguments[arguments.length - 1]);
                    return promise2;
                  };
                };
                for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                  var optionalDriverMethod = OptionalDriverMethods[_i];
                  if (!driverObject[optionalDriverMethod]) {
                    driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                  }
                }
              };
              configureMissingMethods();
              var setDriverSupport = function setDriverSupport2(support) {
                if (DefinedDrivers[driverName]) {
                  console.info("Redefining LocalForage driver: " + driverName);
                }
                DefinedDrivers[driverName] = driverObject;
                DriverSupport[driverName] = support;
                resolve();
              };
              if ("_support" in driverObject) {
                if (driverObject._support && typeof driverObject._support === "function") {
                  driverObject._support().then(setDriverSupport, reject);
                } else {
                  setDriverSupport(!!driverObject._support);
                }
              } else {
                setDriverSupport(true);
              }
            } catch (e) {
              reject(e);
            }
          });
          executeTwoCallbacks(promise, callback, errorCallback);
          return promise;
        };
        LocalForage3.prototype.driver = function driver() {
          return this._driver || null;
        };
        LocalForage3.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
          var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
          executeTwoCallbacks(getDriverPromise, callback, errorCallback);
          return getDriverPromise;
        };
        LocalForage3.prototype.getSerializer = function getSerializer(callback) {
          var serializerPromise = Promise$1.resolve(localforageSerializer);
          executeTwoCallbacks(serializerPromise, callback);
          return serializerPromise;
        };
        LocalForage3.prototype.ready = function ready(callback) {
          var self2 = this;
          var promise = self2._driverSet.then(function() {
            if (self2._ready === null) {
              self2._ready = self2._initDriver();
            }
            return self2._ready;
          });
          executeTwoCallbacks(promise, callback, callback);
          return promise;
        };
        LocalForage3.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
          var self2 = this;
          if (!isArray(drivers)) {
            drivers = [drivers];
          }
          var supportedDrivers = this._getSupportedDrivers(drivers);
          function setDriverToConfig() {
            self2._config.driver = self2.driver();
          }
          function extendSelfWithDriver(driver) {
            self2._extend(driver);
            setDriverToConfig();
            self2._ready = self2._initStorage(self2._config);
            return self2._ready;
          }
          function initDriver(supportedDrivers2) {
            return function() {
              var currentDriverIndex = 0;
              function driverPromiseLoop() {
                while (currentDriverIndex < supportedDrivers2.length) {
                  var driverName = supportedDrivers2[currentDriverIndex];
                  currentDriverIndex++;
                  self2._dbInfo = null;
                  self2._ready = null;
                  return self2.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                }
                setDriverToConfig();
                var error = new Error("No available storage method found.");
                self2._driverSet = Promise$1.reject(error);
                return self2._driverSet;
              }
              return driverPromiseLoop();
            };
          }
          var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
            return Promise$1.resolve();
          }) : Promise$1.resolve();
          this._driverSet = oldDriverSetDone.then(function() {
            var driverName = supportedDrivers[0];
            self2._dbInfo = null;
            self2._ready = null;
            return self2.getDriver(driverName).then(function(driver) {
              self2._driver = driver._driver;
              setDriverToConfig();
              self2._wrapLibraryMethodsWithReady();
              self2._initDriver = initDriver(supportedDrivers);
            });
          })["catch"](function() {
            setDriverToConfig();
            var error = new Error("No available storage method found.");
            self2._driverSet = Promise$1.reject(error);
            return self2._driverSet;
          });
          executeTwoCallbacks(this._driverSet, callback, errorCallback);
          return this._driverSet;
        };
        LocalForage3.prototype.supports = function supports(driverName) {
          return !!DriverSupport[driverName];
        };
        LocalForage3.prototype._extend = function _extend(libraryMethodsAndProperties) {
          extend(this, libraryMethodsAndProperties);
        };
        LocalForage3.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
          var supportedDrivers = [];
          for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
              supportedDrivers.push(driverName);
            }
          }
          return supportedDrivers;
        };
        LocalForage3.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
          for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
          }
        };
        LocalForage3.prototype.createInstance = function createInstance(options) {
          return new LocalForage3(options);
        };
        return LocalForage3;
      }();
      var localforage_js = new LocalForage2();
      module2.exports = localforage_js;
    }, { "3": 3 }] }, {}, [4])(4);
  });
})(localforage);
var LocalForage = localforage.exports;
function localForageFactory(scope) {
  var instance = LocalForage.createInstance({
    name: scope
  });
  instance.config({
    driver: [LocalForage.INDEXEDDB, LocalForage.LOCALSTORAGE]
  });
  return {
    setItem: localforage.exports.setItem,
    getItem: localforage.exports.getItem,
    removeItem: localforage.exports.removeItem
  };
}
function factory(scope) {
  return localForageFactory(scope);
}
var IndexDB = ["crm", "platform", "growth", "mall", "cs"].reduce(function(target, cur) {
  target[cur] = factory(cur);
  return target;
}, {});
function fetcher(promise) {
  return __awaiter(this, void 0, void 0, function() {
    var _a2, success, data, error_1;
    return __generator(this, function(_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 2, , 3]);
          return [4, promise];
        case 1:
          _a2 = _b.sent(), success = _a2.success, data = _a2.data;
          if (success) {
            return [2, data];
          }
          return [3, 3];
        case 2:
          error_1 = _b.sent();
          console.error(error_1);
          return [3, 3];
        case 3:
          throw new Error("fetch error");
      }
    });
  });
}
function useAccessLoader() {
  var dataBus2 = useDataBus();
  function loadAccess() {
    return __awaiter(this, void 0, void 0, function() {
      var res, _a2, func, _b, pcMenu, _c, data_1, menu, funcSet, error_1;
      return __generator(this, function(_d) {
        switch (_d.label) {
          case 0:
            _d.trys.push([0, 2, , 3]);
            return [4, fetcher(fetchAccessData({ type: "pc" }))];
          case 1:
            res = _d.sent();
            _a2 = res.func, func = _a2 === void 0 ? [] : _a2, _b = res.pcMenu, pcMenu = _b === void 0 ? [] : _b, _c = res.data, data_1 = _c === void 0 ? {} : _c, menu = res.menu;
            funcSet = new Set(__spreadArray(__spreadArray([], func, true), pcMenu, true));
            dataBus2.emitData(DataKeys.Access, {
              funcSet,
              data: data_1,
              menu
            }, false);
            return [2, true];
          case 2:
            error_1 = _d.sent();
            console.error(error_1);
            return [3, 3];
          case 3:
            return [2, false];
        }
      });
    });
  }
  function data() {
    return dataBus2.getData(DataKeys.Access, false);
  }
  return {
    loadAccess,
    data
  };
}
function getMenuData() {
  var dataBus2 = useDataBus();
  return dataBus2.getData(DataKeys.Access, false);
}
function isHasFunc(authName, _type) {
  var menu = getMenuData();
  if (!menu || !menu.funcSet)
    return false;
  return menu.funcSet.has(authName);
}
function getDataFunc(menuId, _type) {
  var menu = getMenuData();
  if (!menu || !menu["data"])
    return "";
  return menu["data"][menuId] || "";
}
function getMenuList() {
  var menu = getMenuData();
  return (menu === null || menu === void 0 ? void 0 : menu.menu) || [];
}
function useAccess() {
  var dataBus2 = useDataBus();
  function getFuncSet() {
    var menu = dataBus2.getData(DataKeys.Access, false);
    return (menu === null || menu === void 0 ? void 0 : menu.funcSet) || /* @__PURE__ */ new Set();
  }
  function canUse(code) {
    var funcSet = getFuncSet();
    if (typeof code === "string") {
      return funcSet.has(code);
    } else {
      return code.every(function(c) {
        return funcSet.has(c);
      });
    }
  }
  function canUseMethod(name) {
    var func = CoreSdk.getAccessMethod(name);
    if (!func) {
      return false;
    }
    return func(getFuncSet());
  }
  return {
    canUse,
    canUseMethod
  };
}
function useAppConfig() {
}
function isObject$1(data) {
  return typeof data === "object" || Object.prototype.toString.call(data) === "[object Object]";
}
var EnvManagerImp = function() {
  function EnvManagerImp2(option) {
    if (option === void 0) {
      option = {};
    }
    Object.defineProperty(this, "env", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    var buildEnv = process.env || {};
    var deployEnv = {};
    var devEnv = {};
    if (typeof window !== "undefined") {
      deployEnv = window[option.key || "envConfig"] || {};
    }
    if (buildEnv.NODE_ENV === "development" && isObject$1(option.developmentEnvs)) {
      devEnv = __assign({}, option.developmentEnvs);
    }
    this.env = Object.freeze(__assign(__assign(__assign({}, buildEnv), deployEnv), devEnv));
  }
  Object.defineProperty(EnvManagerImp2.prototype, "get", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(key) {
      var isValid = Object.hasOwnProperty.call(this.env, key);
      if (!isValid) {
        throw new Error("\u5F53\u524D\u7684\u73AF\u5883\u53D8\u91CF\u96C6\u5408\u4E2D\u4E0D\u5B58\u5728\u3010".concat(key, "\u3011\uFF0C\u8BF7\u68C0\u67E5\u53D8\u91CF\u540D\u79F0\u662F\u5426\u6B63\u786E"));
      }
      return this.env[key];
    }
  });
  Object.defineProperty(EnvManagerImp2.prototype, "getBaseUrl", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(platform) {
      if (platform === void 0) {
        platform = "pc";
      }
      return platform === "pc" ? this.get("VUE_APP_PC_B_BASE_URL") : this.get("VUE_APP_QW_SCRM_BASE_URL");
    }
  });
  Object.defineProperty(EnvManagerImp2.prototype, "getSocketUrl", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      return this.get("VUE_APP_WEBSOCKET_BASE_URL") + "/sub";
    }
  });
  return EnvManagerImp2;
}();
var EnvManager = new EnvManagerImp();
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function isObject(data) {
  return Object.prototype.toString.call(data) === "[object Object]";
}
var RuntimeEnvManager = /* @__PURE__ */ function() {
  function RuntimeEnvManager2(options) {
    if (options === void 0) {
      options = {};
    }
    var compileEnvs = process.env;
    var runtimeEnvs = {};
    var devInjectEnvs = {};
    if (typeof window !== "undefined") {
      runtimeEnvs = window[options.key || "envConfig"] || {};
    }
    if (compileEnvs.NODE_ENV === "development" && isObject(options.devInjectEnvs)) {
      devInjectEnvs = _extends({}, options.devInjectEnvs);
    }
    this.env = Object.freeze(_extends({}, compileEnvs, runtimeEnvs, devInjectEnvs));
  }
  var _proto = RuntimeEnvManager2.prototype;
  _proto.get = function get(key) {
    var isValid = Object.hasOwnProperty.call(this.env, key);
    if (!isValid) {
      throw new Error("\u5F53\u524D\u7684\u73AF\u5883\u53D8\u91CF\u96C6\u5408\u4E2D\u4E0D\u5B58\u5728[" + key + "]\uFF0C\u8BF7\u68C0\u67E5\u53D8\u91CF\u540D\u79F0\u662F\u5426\u6B63\u786E");
    }
    return this.env[key];
  };
  return RuntimeEnvManager2;
}();
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function() {
    return exports;
  };
  var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self2, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
    return generator._invoke = function(innerFn2, self3, context2) {
      var state = "suspendedStart";
      return function(method, arg) {
        if ("executing" === state)
          throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method)
            throw arg;
          return doneResult();
        }
        for (context2.method = method, context2.arg = arg; ; ) {
          var delegate = context2.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context2);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel)
                continue;
              return delegateResult;
            }
          }
          if ("next" === context2.method)
            context2.sent = context2._sent = context2.arg;
          else if ("throw" === context2.method) {
            if ("suspendedStart" === state)
              throw state = "completed", context2.arg;
            context2.dispatchException(context2.arg);
          } else
            "return" === context2.method && context2.abrupt("return", context2.arg);
          state = "executing";
          var record = tryCatch(innerFn2, self3, context2);
          if ("normal" === record.type) {
            if (state = context2.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel)
              continue;
            return {
              value: record.arg,
              done: context2.done
            };
          }
          "throw" === record.type && (state = "completed", context2.method = "throw", context2.arg = record.arg);
        }
      };
    }(innerFn, self2, context), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function() {
    return this;
  });
  var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg, value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value2) {
          invoke("next", value2, resolve, reject);
        }, function(err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function(unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function(error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    this._invoke = function(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (void 0 === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method))
          return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type)
      return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod)
        return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next)
        return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1, next = function next2() {
          for (; ++i < iterable.length; )
            if (hasOwn.call(iterable, i))
              return next2.value = iterable[i], next2.done = false, next2;
          return next2.value = void 0, next2.done = true, next2;
        };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: void 0,
      done: true
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function(genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function(arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
    return this;
  }), define(Gp, "toString", function() {
    return "[object Generator]";
  }), exports.keys = function(object) {
    var keys = [];
    for (var key in object)
      keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length; ) {
        var key2 = keys.pop();
        if (key2 in object)
          return next.value = key2, next.done = false, next;
      }
      return next.done = true, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset)
        for (var name in this)
          "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
    },
    stop: function() {
      this.done = true;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type)
        throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function(exception) {
      if (this.done)
        throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i], record = entry.completion;
        if ("root" === entry.tryLoc)
          return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc)
              return handle(entry.catchLoc, true);
            if (this.prev < entry.finallyLoc)
              return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc)
              return handle(entry.catchLoc, true);
          } else {
            if (!hasFinally)
              throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc)
              return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function(record, afterLoc) {
      if ("throw" === record.type)
        throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc)
          return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName,
        nextLoc
      }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
function myFetch(_x) {
  return _myFetch.apply(this, arguments);
}
function _myFetch() {
  _myFetch = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(params) {
    var url, res, resJson;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = params.url;
            _context.next = 3;
            return fetch(url, {
              method: "get"
            });
          case 3:
            res = _context.sent;
            _context.next = 6;
            return res.json();
          case 6:
            _context.t0 = _context.sent;
            if (_context.t0) {
              _context.next = 9;
              break;
            }
            _context.t0 = {};
          case 9:
            resJson = _context.t0;
            return _context.abrupt("return", resJson);
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _myFetch.apply(this, arguments);
}
function getCdnFileUrl(params) {
  var prefix = params.prefix, key = params.key, field = params.field, fileType = params.fileType, teamName = params.teamName, timestamp = params.timestamp;
  var envName = params.envName;
  var fileName = key + "." + fileType;
  envName === "dev" && (envName = "dev1");
  envName === "master" && (envName = "master1");
  envName === "release" && (envName = "ali");
  var path = "/cfx-config-platform/" + field + "/" + (teamName ? "teamName/" : "") + envName + "/" + fileName;
  if (timestamp)
    path += "?time=" + Date.now();
  return "" + prefix + path;
}
function useCDN(_x, _x2, _x3) {
  return _useCDN.apply(this, arguments);
}
function _useCDN() {
  _useCDN = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(key, timestamp, envFrom) {
    var env, VUE_APP_ICONFIG_CDN_PREFIX, VUE_APP_ICONFIG_FIELD_NAME, VUE_APP_ICONFIG_ENV, VUE_APP_MKCONFIG_ENV, url, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (timestamp === void 0) {
              timestamp = true;
            }
            if (envFrom === void 0) {
              envFrom = "window";
            }
            env = envFrom === "window" ? new RuntimeEnvManager().env : process.env;
            VUE_APP_ICONFIG_CDN_PREFIX = env.VUE_APP_ICONFIG_CDN_PREFIX, VUE_APP_ICONFIG_FIELD_NAME = env.VUE_APP_ICONFIG_FIELD_NAME, VUE_APP_ICONFIG_ENV = env.VUE_APP_ICONFIG_ENV, VUE_APP_MKCONFIG_ENV = env.VUE_APP_MKCONFIG_ENV;
            url = getCdnFileUrl({
              key,
              prefix: VUE_APP_ICONFIG_CDN_PREFIX,
              field: VUE_APP_ICONFIG_FIELD_NAME || "scrm",
              envName: VUE_APP_ICONFIG_ENV || VUE_APP_MKCONFIG_ENV,
              fileType: "json",
              timestamp
            });
            _context.next = 7;
            return myFetch({
              url
            });
          case 7:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _useCDN.apply(this, arguments);
}
var OEM = {};
var stack = [];
function emitUpdate(result) {
  useDataBus().emitData(DataKeys.OEM, result, false);
  stack.forEach(function(cb) {
    if (typeof cb === "function") {
      cb(result);
    }
  });
}
function merge() {
  var dataArray = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    dataArray[_i] = arguments[_i];
  }
  var result = OEM;
  Object.assign.apply(Object, __spreadArray([result], dataArray, false));
  return result;
}
function isEmptyObject(target) {
  if (target === null) {
    return true;
  }
  if (typeof target === "object") {
    return !Object.keys(target).length;
  }
  return false;
}
function fetchCustomizeOEM() {
  return __awaiter(this, void 0, void 0, function() {
    var corpId, _a2, success, data;
    return __generator(this, function(_b) {
      switch (_b.label) {
        case 0:
          corpId = new URLSearchParams(location.href.split("?")[1]).get("corpId") || getUser().corpId || "";
          if (!corpId) {
            return [2, {}];
          }
          return [4, CoreSdk.network.get("account/v1/enterprise_info", { corpId })];
        case 1:
          _a2 = _b.sent(), success = _a2.success, data = _a2.data;
          return [2, success ? data : {}];
      }
    });
  });
}
function fetchAgentOEM() {
  return __awaiter(this, void 0, void 0, function() {
    var _a2, success, data;
    return __generator(this, function(_b) {
      switch (_b.label) {
        case 0:
          return [4, CoreSdk.network.get("/biz/v1/qw_account/anonymous/oem/agent", {
            domain: window.location.host
          }, {
            baseURL: EnvManager.get("VUE_APP_QW_SCRM_BASE_URL")
          })];
        case 1:
          _a2 = _b.sent(), success = _a2.success, data = _a2.data;
          return [2, success ? data : null];
      }
    });
  });
}
function fetchDefaultOEM() {
  return __awaiter(this, void 0, void 0, function() {
    var data, e_1;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          _a2.trys.push([0, 2, , 3]);
          return [4, useCDN("oemConfig")];
        case 1:
          data = _a2.sent();
          return [2, data || {}];
        case 2:
          e_1 = _a2.sent();
          console.log(e_1, "\u83B7\u53D6oem\u914D\u7F6E\u6587\u4EF6\u9519\u8BEF");
          return [2, {}];
        case 3:
          return [2];
      }
    });
  });
}
function useOEM() {
  var _this = this;
  var setOEM = function(oemData) {
    var result = merge(oemData);
    emitUpdate(result);
    return result;
  };
  var fetchOEM = function() {
    return __awaiter(_this, void 0, void 0, function() {
      var agentOEM, customizeOEM, result, defaultOEM, defaultOEM;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, fetchAgentOEM()];
          case 1:
            agentOEM = _a2.sent();
            return [4, fetchCustomizeOEM()];
          case 2:
            customizeOEM = _a2.sent();
            result = {};
            if (!(agentOEM && !isEmptyObject(agentOEM)))
              return [3, 5];
            if (!!agentOEM.icon)
              return [3, 4];
            return [4, fetchDefaultOEM()];
          case 3:
            defaultOEM = _a2.sent();
            agentOEM.icon = defaultOEM.icon || defaultOEM.defaultIcon;
            _a2.label = 4;
          case 4:
            result = merge(agentOEM, customizeOEM);
            return [3, 7];
          case 5:
            return [4, fetchDefaultOEM()];
          case 6:
            defaultOEM = _a2.sent();
            result = merge(defaultOEM, customizeOEM);
            _a2.label = 7;
          case 7:
            emitUpdate(result);
            return [2, result];
        }
      });
    });
  };
  var onUpdate = function(cb) {
    stack.push(cb);
  };
  function getOEM() {
    return useDataBus().getData(DataKeys.OEM, false) || {};
  }
  return {
    fetchOEM,
    setOEM,
    onUpdate,
    getOEM
  };
}
function useAppVersion() {
}
function useSwitchConfig() {
  var dataBus2 = useDataBus();
  function loadSwitchConfig() {
    return __awaiter(this, void 0, void 0, function() {
      var data_1, error_1;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            _a2.trys.push([0, 2, , 3]);
            return [4, fetcher(fetchSwitchConfig())];
          case 1:
            data_1 = _a2.sent();
            dataBus2.emitData(DataKeys.SwitchConfig, data_1, false);
            return [2, true];
          case 2:
            error_1 = _a2.sent();
            console.error(error_1);
            return [3, 3];
          case 3:
            return [2, false];
        }
      });
    });
  }
  function data() {
    return dataBus2.getData(DataKeys.SwitchConfig, false);
  }
  return {
    loadSwitchConfig,
    data
  };
}
function hasSwitchConfig(key) {
  var data = CoreSdk.dataManager.switchData();
  if (!data) {
    return false;
  }
  return data[key];
}
var AccountType;
(function(AccountType2) {
  AccountType2["Self"] = "Self";
  AccountType2["Third"] = "Third";
  AccountType2["Provided"] = "Provided";
  AccountType2["ProvidedUpgraded"] = "ProvidedUpgraded";
})(AccountType || (AccountType = {}));
function getTenantType() {
  return useDataBus().getData(DataKeys.TenantType, false);
}
function isProvidedUpgraded() {
  return getTenantType() === AccountType.ProvidedUpgraded;
}
function useTenantType() {
  var dataBus2 = useDataBus();
  function fetchTenantType() {
    return __awaiter(this, void 0, void 0, function() {
      var _a2, code, data;
      return __generator(this, function(_b) {
        switch (_b.label) {
          case 0:
            return [4, CoreSdk.network.webGateway({
              optionName: "mk-wxwork-api.mkwxworkapi.AccountType.Query"
            })];
          case 1:
            _a2 = _b.sent(), code = _a2.code, data = _a2.data;
            if (code === "0") {
              dataBus2.emitData(DataKeys.TenantType, data.type, false);
              return [2, true];
            }
            return [2, false];
        }
      });
    });
  }
  return {
    fetchTenantType
  };
}
function useDataManage() {
  var access = useAccessLoader();
  var switchConfig = useSwitchConfig();
  function loadData() {
    return __awaiter(this, void 0, void 0, function() {
      var result;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, Promise.all([
              access.loadAccess(),
              switchConfig.loadSwitchConfig()
            ])];
          case 1:
            result = _a2.sent();
            return [2, !result.some(function(res) {
              return !res;
            })];
        }
      });
    });
  }
  return {
    loadData,
    accessData: access.data,
    switchData: switchConfig.data
  };
}
var IFrameComponents = [
  {
    id: "if-1111",
    type: "iframe",
    config: {
      url: "http://www.baidu.com"
    }
  }
];
var MFComponents = [
  {
    id: "mf-001",
    type: "mf",
    config: {
      name: "",
      scope: "",
      publicPath: "/"
    }
  }
];
var MicroComponents = [
  {
    id: "app-12132",
    type: "micro",
    config: {
      name: "",
      path: ""
    }
  }
];
function arrayToMap(options, extraMap) {
  var map = /* @__PURE__ */ new Map();
  if (!options) {
    return map;
  }
  options.forEach(function(c) {
    if (!c.id) {
      return;
    }
    var extraOptions = extraMap === null || extraMap === void 0 ? void 0 : extraMap.get(c.id);
    if (extraOptions) {
      extraMap === null || extraMap === void 0 ? void 0 : extraMap.delete(c.id);
      map.set(c.id, __assign(__assign({}, c), extraOptions));
      return;
    }
    map.set(c.id, c);
  });
  if (extraMap === null || extraMap === void 0 ? void 0 : extraMap.size) {
    extraMap.forEach(function(v, key) {
      map.set(key, v);
    });
  }
  return map;
}
function usePresetGlobalComponents(options) {
  var optionsMap = arrayToMap(options);
  var components = __spreadArray(__spreadArray(__spreadArray([], MFComponents, true), IFrameComponents, true), MicroComponents, true);
  var map = arrayToMap(components, optionsMap);
  return map;
}
var getActiveRule = function(hash) {
  return function(location2) {
    return location2.hash.startsWith(hash);
  };
};
var MicroApps = [
  {
    name: "scrm-manage-workbench",
    publicPath: "workbench",
    port: 5001,
    activeRule: getActiveRule("#/workbench")
  },
  {
    name: "qw-manage-work-order-client",
    publicPath: "workorder",
    port: 3001,
    activeRule: getActiveRule("#/workbench")
  },
  {
    name: "qw-manage-crm-report-client",
    publicPath: "crm-report",
    port: 3001,
    activeRule: getActiveRule("#/workbench")
  },
  {
    name: "scrm-manage-customer",
    publicPath: "scrm-manage-customer",
    port: 4003,
    activeRule: getActiveRule("#/customer")
  },
  {
    name: "scrm-manage-salechance",
    publicPath: "scrm-manage-salechance",
    port: 4002,
    activeRule: getActiveRule("#/customer")
  },
  {
    name: "scrm-manage-opensea",
    publicPath: "scrm-manage-opensea",
    port: 4100,
    activeRule: getActiveRule("#/customer")
  }
];
function generateAppMap(source) {
  var map = /* @__PURE__ */ new Map();
  source.forEach(function(app) {
    map.set(app.name, app);
  });
  return map;
}
function useMicroAppConfig() {
  var appMap = generateAppMap(MicroApps);
  function registerApps(apps) {
    if (!apps.length) {
      return;
    }
    apps.forEach(function(app) {
      var source = appMap.get(app.name) || {};
      appMap.set(app.name, Object.assign({}, source, app));
    });
  }
  function getApp(name, extra) {
    if (extra === void 0) {
      extra = {};
    }
    var source = appMap.get(name);
    if (source) {
      return __assign(__assign({}, source), extra);
    }
    return extra;
  }
  return {
    registerApps,
    getApp
  };
}
var MicroAppManager = useMicroAppConfig();
function useRef(initValue) {
  var ref = { value: initValue };
  return {
    value: function() {
      return ref.value;
    },
    setValue: function(v) {
      ref.value = v;
    }
  };
}
function useGlobalComponentsServer() {
  var dataBus2 = useDataBus();
  var presenterRef = useRef();
  var eventBus = useEventBus();
  var destroy;
  function registerGlobalComponents(options) {
    dataBus2.emitData(DataKeys.Components, usePresetGlobalComponents(options), false);
  }
  function getComponent(id) {
    var map = dataBus2.getData(DataKeys.Components, false);
    return map === null || map === void 0 ? void 0 : map.get(id);
  }
  function present(config) {
    return __awaiter(this, void 0, void 0, function() {
      var presenter, cc;
      return __generator(this, function(_a2) {
        presenter = presenterRef.value();
        if (!presenter) {
          console.error("Not register components presenter");
          return [2, false];
        }
        cc = getComponent(config.id);
        if (!cc) {
          eventBus.dispatch(EventKeys.PresentEventApp, config);
          return [2, false];
        }
        return [2, presenter(__assign(__assign({}, cc), config))];
      });
    });
  }
  function registerPresenter(presenter) {
    var _this = this;
    var onPresent = function(_a2) {
      var detail = _a2.detail;
      return __awaiter(_this, void 0, void 0, function() {
        return __generator(this, function(_b) {
          switch (_b.label) {
            case 0:
              return [4, present(detail)];
            case 1:
              _b.sent();
              return [2];
          }
        });
      });
    };
    if (destroy) {
      destroy();
    }
    presenterRef.setValue(presenter);
    eventBus.on(EventKeys.PresentEvent, onPresent);
    destroy = function() {
      eventBus.off(EventKeys.PresentEvent, onPresent);
      presenterRef.setValue(void 0);
    };
    return destroy;
  }
  return {
    registerGlobalComponents,
    registerPresenter
  };
}
var GlobalComponentServer = useGlobalComponentsServer();
function useGlobalComponentClient() {
  var eventBus = useEventBus();
  function present(event) {
    useNextTask(function() {
      eventBus.dispatch(EventKeys.PresentEvent, event);
    });
  }
  function presentCompatible(id, props, mode) {
    return present({
      id,
      props,
      mode
    });
  }
  function destroy(id) {
    useNextTask(function() {
      eventBus.dispatch(EventKeys.HiddenComponent, { id });
    });
  }
  return {
    present,
    presentCompatible,
    destroy
  };
}
var GlobalComponentClient = useGlobalComponentClient();
var post = function(url, data, options) {
  return CoreSdk.network.post(url, data, __assign({ baseURL: EnvManager.getBaseUrl("pc") || void 0 }, options));
};
var createModelData = function(data, options) {
  return post("/model_center/api/v2/model_data/create", data, options);
};
var editModelData = function(data, options) {
  return post("/model_center/api/v2/model_data/update", data, options);
};
var deleteModelData = function(data, options) {
  return post("/model_center/api/v2/model_data/delete", data, options);
};
var queryModelDataList = function(data, options) {
  return post("/model_center/api/v2/model_data/query", data, options);
};
var ModelCenterConfig = {
  DraftBox: {
    id: "be981ff8abb33729020ff62d969369c6"
  }
};
var QueryBuilder = function() {
  function QueryBuilder2() {
    Object.defineProperty(this, "body", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
  }
  Object.defineProperty(QueryBuilder2.prototype, "withPage", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(pageNo, pageSize) {
      if (pageNo === void 0) {
        pageNo = 1;
      }
      if (pageSize === void 0) {
        pageSize = 20;
      }
      this.body.pager = { pageNo, pageSize };
      return this;
    }
  });
  Object.defineProperty(QueryBuilder2.prototype, "withCondition", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(op, fields) {
      if (!this.body[op]) {
        this.body[op] = {};
      }
      Object.assign(this.body[op], fields);
      return this;
    }
  });
  Object.defineProperty(QueryBuilder2.prototype, "withSort", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(sort) {
      if (!this.body.sort) {
        this.body.sort = {};
      }
      Object.assign(this.body.sort, sort);
      return this;
    }
  });
  Object.defineProperty(QueryBuilder2.prototype, "withSetter", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(setter) {
      if (!this.body.setter) {
        this.body.setter = {};
      }
      Object.assign(this.body.setter, setter);
      return this;
    }
  });
  Object.defineProperty(QueryBuilder2.prototype, "build", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      return this.body;
    }
  });
  return QueryBuilder2;
}();
var _a;
var DraftType = {
  CreateCustomer: "draft.type.customer.form",
  CreateWorkOrder: "draft.type.workorder.form",
  CreateOrder: "draft.type.order.form",
  DraftTest: "draft.type.for.test"
};
var DraftTitleName = (_a = {}, _a[DraftType.CreateCustomer] = "\u65B0\u5EFA\u8054\u7CFB\u4EBA", _a[DraftType.CreateWorkOrder] = "\u65B0\u5EFA\u5DE5\u5355", _a[DraftType.CreateOrder] = "\u65B0\u5EFA\u8BA2\u5355", _a[DraftType.DraftTest] = "\u8349\u7A3F\u7BB1\u6D4B\u8BD5", _a);
var __ID = "id.string";
function useDraftBox(_a2) {
  var type = _a2.type;
  var id = ModelCenterConfig.DraftBox.id;
  var userRef = useRef();
  var draftData = {};
  var extra = {
    header: {
      "X-Model-Definition-Unique-Id": id
    }
  };
  function checkUser() {
    var _a3;
    if (!userRef.value()) {
      userRef.setValue(getUser());
    }
    var validate = !!((_a3 = userRef.value()) === null || _a3 === void 0 ? void 0 : _a3.sid);
    if (!validate) {
      console.error("\u672A\u83B7\u53D6\u5230\u7528\u6237\u4FE1\u606F\uFF0C\u65E0\u6CD5\u8C03\u7528\u8349\u7A3F\u7BB1\u76F8\u5173\u63A5\u53E3");
    }
    return validate;
  }
  function stringify(data) {
    try {
      return JSON.stringify(data);
    } catch (error) {
    }
    return "";
  }
  function parse(json) {
    try {
      return JSON.parse(json);
    } catch (error) {
    }
    return void 0;
  }
  function getEditData(draft, drafts_content) {
    draft.formData;
    var reset = __rest(draft, ["formData"]);
    return new QueryBuilder().withCondition("eq", {
      id: draftData[__ID]
    }).withSetter(__assign(__assign({}, reset), { drafts_content })).build();
  }
  function save(draft) {
    return __awaiter(this, void 0, void 0, function() {
      var _a3, title_name, reset, json, isEdit, api2, user, data, _b, code, resp;
      return __generator(this, function(_c) {
        switch (_c.label) {
          case 0:
            if (!checkUser()) {
              return [2, false];
            }
            draft.formData, _a3 = draft.title_name, title_name = _a3 === void 0 ? DraftTitleName[type] : _a3, reset = __rest(draft, ["formData", "title_name"]);
            json = stringify(draft.formData);
            if (!json) {
              console.warn("\u6570\u636E\u8F6Cjson\u5931\u8D25");
              return [2, false];
            }
            isEdit = !!draftData[__ID];
            api2 = isEdit ? editModelData : createModelData;
            user = userRef.value();
            data = isEdit ? getEditData(draft, json) : {
              model_data: [
                __assign(__assign({}, reset), { title_name, drafts_content: json, uid: user === null || user === void 0 ? void 0 : user.uid, user_name: user === null || user === void 0 ? void 0 : user.name, type })
              ]
            };
            return [4, api2(data, extra)];
          case 1:
            _b = _c.sent(), code = _b.code, resp = _b.data;
            if (code === 0 && resp.succeed) {
              if (isEdit) {
                Object.assign(draftData, __assign(__assign({}, reset), { title_name, drafts_content: json }));
              } else {
                draftData = (resp.echo || [])[0] || {};
              }
              return [2, true];
            }
            return [2, false];
        }
      });
    });
  }
  function check() {
    return __awaiter(this, void 0, void 0, function() {
      var uid, queryBody, _a3, code, data;
      return __generator(this, function(_b) {
        switch (_b.label) {
          case 0:
            if (!checkUser()) {
              return [2, false];
            }
            uid = userRef.value().uid;
            queryBody = new QueryBuilder().withPage().withCondition("eq", {
              uid,
              type
            }).build();
            return [4, queryModelDataList(queryBody, extra)];
          case 1:
            _a3 = _b.sent(), code = _a3.code, data = _a3.data;
            if (code === 0 && data) {
              draftData = (data.list || [])[0] || {};
              return [2, !!draftData[__ID]];
            }
            return [2, false];
        }
      });
    });
  }
  function clear() {
    return __awaiter(this, void 0, void 0, function() {
      var data, code;
      return __generator(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            if (!draftData[__ID]) {
              console.warn("\u4E0D\u5B58\u5728\u8349\u7A3F\uFF0C\u65E0\u6CD5\u5220\u9664");
              return [2, true];
            }
            data = new QueryBuilder().withCondition("eq", {
              id: draftData[__ID]
            }).build();
            return [4, deleteModelData(data, extra)];
          case 1:
            code = _a3.sent().code;
            if (code === 0) {
              draftData = {};
              return [2, true];
            }
            return [2, false];
        }
      });
    });
  }
  function get() {
    if (draftData.drafts_content) {
      return parse(draftData.drafts_content);
    }
    return void 0;
  }
  return {
    save,
    check,
    clear,
    get
  };
}
var _CoreSdkImp_accessMethodMap, _CoreSdkImp_noAuth, _CoreSdkImp_platform, _CoreSdkImp_noFetchBaseData;
function useSdkState() {
  var dataBus2 = useDataBus();
  function setState(state) {
    dataBus2.emitData(DataKeys.InitSdk, state, false);
  }
  function getState() {
    return !!dataBus2.getData(DataKeys.InitSdk, false);
  }
  return {
    setState,
    getState
  };
}
var CoreSdkImp = function() {
  function CoreSdkImp2() {
    Object.defineProperty(this, "network", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "dataManager", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: useDataManage()
    });
    Object.defineProperty(this, "websocket", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    _CoreSdkImp_accessMethodMap.set(this, {});
    _CoreSdkImp_noAuth.set(this, false);
    _CoreSdkImp_platform.set(this, "pc");
    _CoreSdkImp_noFetchBaseData.set(this, false);
    Object.defineProperty(this, "status", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "idle"
    });
    Object.defineProperty(this, "globalState", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: useSdkState()
    });
  }
  Object.defineProperty(CoreSdkImp2.prototype, "initOem", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      return __awaiter(this, void 0, void 0, function() {
        var result;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, useOEM().fetchOEM()];
            case 1:
              result = _a2.sent();
              return [2, !!Object.keys(result).length];
          }
        });
      });
    }
  });
  Object.defineProperty(CoreSdkImp2.prototype, "initSdk", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(_a2) {
      var useNetwork2 = _a2.useNetwork, useWebSocket = _a2.useWebSocket, accessMethodMap = _a2.accessMethodMap, _b = _a2.sessionLoginOptions, sessionLoginOptions = _b === void 0 ? {} : _b, _c = _a2.noAuth, noAuth = _c === void 0 ? false : _c, platform = _a2.platform, _d = _a2.noFetchBaseData, noFetchBaseData = _d === void 0 ? false : _d;
      return __awaiter(this, void 0, void 0, function() {
        var auth, success;
        return __generator(this, function(_e) {
          switch (_e.label) {
            case 0:
              this.network = useNetwork2;
              __classPrivateFieldSet(this, _CoreSdkImp_platform, platform || "pc", "f");
              __classPrivateFieldSet(this, _CoreSdkImp_noAuth, noAuth, "f");
              __classPrivateFieldSet(this, _CoreSdkImp_noFetchBaseData, noFetchBaseData, "f");
              if (accessMethodMap) {
                __classPrivateFieldSet(this, _CoreSdkImp_accessMethodMap, accessMethodMap, "f");
              }
              if (!this.globalState.getState())
                return [3, 1];
              if (!noAuth && !getUserSid(platform)) {
                return [2, false];
              }
              this.status = "init";
              this.notifySuccess();
              return [2, true];
            case 1:
              if (!!noAuth)
                return [3, 3];
              sessionLoginOptions = __assign(__assign({}, sessionLoginOptions), { type: __classPrivateFieldGet(this, _CoreSdkImp_platform, "f") });
              return [4, useSessionLogin(sessionLoginOptions)];
            case 2:
              auth = _e.sent();
              if (!auth) {
                console.error("user auth error");
                this.status = "fail";
                return [2, false];
              }
              _e.label = 3;
            case 3:
              if (useWebSocket) {
                this.websocket = useGlobalWebsocket(useWebSocket);
              }
              return [4, this.reloadData()];
            case 4:
              success = _e.sent();
              return [2, success];
          }
        });
      });
    }
  });
  Object.defineProperty(CoreSdkImp2.prototype, "notifySuccess", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      EventBus.dispatch(EventKeys.InitCoreSdk, { success: true });
      this.globalState.setState(true);
    }
  });
  Object.defineProperty(CoreSdkImp2.prototype, "reloadData", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      return __awaiter(this, void 0, void 0, function() {
        var result, success;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!this.network) {
                return [2, false];
              }
              if (__classPrivateFieldGet(this, _CoreSdkImp_noFetchBaseData, "f") || __classPrivateFieldGet(this, _CoreSdkImp_platform, "f") === "qw")
                return [
                  2,
                  true
                ];
              return [4, Promise.all(__classPrivateFieldGet(this, _CoreSdkImp_noAuth, "f") ? [this.initOem()] : [this.initOem(), this.loadGlobalData()])];
            case 1:
              result = _a2.sent();
              success = !result.some(function(s) {
                return !s;
              });
              this.status = success ? "init" : "fail";
              if (success) {
                this.notifySuccess();
              }
              return [2, success];
          }
        });
      });
    }
  });
  Object.defineProperty(CoreSdkImp2.prototype, "isInit", {
    get: function() {
      return this.status === "init";
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CoreSdkImp2.prototype, "getStatus", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      return this.status;
    }
  });
  Object.defineProperty(CoreSdkImp2.prototype, "loadGlobalData", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          return [2, this.dataManager.loadData()];
        });
      });
    }
  });
  Object.defineProperty(CoreSdkImp2.prototype, "getAccessMethod", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(name) {
      return __classPrivateFieldGet(this, _CoreSdkImp_accessMethodMap, "f")[name];
    }
  });
  Object.defineProperty(CoreSdkImp2.prototype, "destroy", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function() {
      var _a2;
      __classPrivateFieldSet(this, _CoreSdkImp_accessMethodMap, {}, "f");
      GlobalState.destroy();
      (_a2 = this.websocket) === null || _a2 === void 0 ? void 0 : _a2.destroy();
    }
  });
  return CoreSdkImp2;
}();
_CoreSdkImp_accessMethodMap = /* @__PURE__ */ new WeakMap(), _CoreSdkImp_noAuth = /* @__PURE__ */ new WeakMap(), _CoreSdkImp_platform = /* @__PURE__ */ new WeakMap(), _CoreSdkImp_noFetchBaseData = /* @__PURE__ */ new WeakMap();
var CoreSdk = new CoreSdkImp();
function fetchLoginSession(params) {
  return CoreSdk.network.get("/biz/v1/qw_account/session/get_login_session", params);
}
function fetchAccessData(data) {
  return CoreSdk.network.get("/biz/v1/qw_account/menu/sort/list", data);
}
function fetchSwitchConfig() {
  return CoreSdk.network.get("/qw-scrm-svc/action/common/switchConfig", {});
}
var WhiteList = ["/login", "/no-auth"];
var getNoAuthPage = function(platform) {
  if (platform === "pc") {
    if (location.pathname.includes("scrm-manage")) {
      return "/scrm-manage/no-auth";
    }
    return "/qw-manage/#/no-auth";
  }
  return "/common-login/#/error?code=999999";
};
function inWhiteList(list) {
  var url = location.href;
  return (list || []).some(function(item) {
    return url.includes(item);
  });
}
function navigateToNoAuth(noAuthPage, query) {
  if (!noAuthPage) {
    return;
  }
  var path = typeof noAuthPage === "function" ? noAuthPage() : noAuthPage;
  RouterUtils.replace({
    path,
    query
  });
}
function isThirdApp(platform) {
  if (platform === void 0) {
    platform = "pc";
  }
  var THIRDAPP_TYPE = 1;
  var user = getUser(platform);
  if (!user) {
    if (isDev())
      return false;
    var reg = /[A-Za-z0-9-]+-qw-scrm/;
    var origin_1 = window.location.origin;
    if (reg.test(origin_1)) {
      return false;
    }
    return true;
  }
  if (!user.account_type)
    return false;
  return user.account_type === THIRDAPP_TYPE;
}
var getPcLoginPage = function() {
  if (location.pathname.includes("scrm-manage")) {
    return "/scrm-manage/login";
  }
  return "/qw-manage/#/login";
};
function pcNavigateToLogin(authPage) {
  var path = typeof authPage === "function" ? authPage() : getPcLoginPage();
  var _a2 = getAgentConfig("pc") || {}, agentId = _a2.agentId, corpId = _a2.corpId;
  var replaceParams = {
    path
  };
  if (agentId && corpId)
    replaceParams.query = {
      corpId,
      agentId
    };
  if (isThirdApp()) {
    replaceParams.query = __assign(__assign({}, replaceParams.query), { third: "true" });
  }
  RouterUtils.replace(replaceParams);
}
var getRedirectURL = function(config) {
  var _a2 = window.location, origin = _a2.origin, pathname = _a2.pathname, hash = _a2.hash;
  var _b = hash.split("?"), realHash = _b[0], firstQuery = _b[1];
  var fixedQuerys = "corpId=".concat(config.corpId || config.corpid, "&agentId=").concat(config.agentId, "&autoLogin=true");
  if (firstQuery) {
    var params_1 = [
      "isSideMenu",
      "corpId",
      "agentId",
      "autoLogin",
      "sessionId"
    ];
    var uniqueParams_1 = {};
    firstQuery.split("&").forEach(function(it) {
      var _a22 = it.split("="), key = _a22[0], val = _a22[1];
      if (val && !params_1.includes(key)) {
        uniqueParams_1[key] = val;
      }
    });
    var extraQuerys = Object.keys(uniqueParams_1).map(function(it) {
      return "".concat(it, "=").concat(uniqueParams_1[it]);
    }).join("&");
    fixedQuerys = "".concat(fixedQuerys, "&").concat(extraQuerys);
  }
  return "".concat(origin).concat(pathname).concat(realHash, "?").concat(fixedQuerys);
};
function qwNavigateToLogin() {
  var origin = window.location.origin;
  var config = getAgentConfig("qw");
  var corpId = config.corpId || config.corpid;
  var reloadURL = "".concat(origin, "/common-login/#/error?code=999999");
  if (corpId) {
    var redirect = getRedirectURL(config);
    reloadURL = "".concat(origin, "/wxwork/v1/auth?corpId=").concat(corpId, "&state=123&redirect=").concat(encodeURIComponent(redirect));
  }
  window.location.replace(reloadURL);
}
function checkSession(sessionId, options) {
  return __awaiter(this, void 0, void 0, function() {
    var _a2, noAuthPageParams, _b, redirectNoAuth, onError, _c, type, noAuthPage, res, _d, success, data, code, msg, companyStatus, scrmEnable, identity, error_1;
    return __generator(this, function(_e) {
      switch (_e.label) {
        case 0:
          _a2 = options || {}, noAuthPageParams = _a2.noAuthPage, _b = _a2.redirectNoAuth, redirectNoAuth = _b === void 0 ? true : _b, onError = _a2.onError, _c = _a2.type, type = _c === void 0 ? "pc" : _c;
          noAuthPage = noAuthPageParams || getNoAuthPage.bind(type);
          _e.label = 1;
        case 1:
          _e.trys.push([1, 3, , 4]);
          return [4, fetchLoginSession({
            sessionId,
            type
          })];
        case 2:
          res = _e.sent();
          _d = res, success = _d.success, data = _d.data, code = _d.code, msg = _d.msg;
          if (success) {
            companyStatus = data.companyStatus, scrmEnable = data.scrmEnable, identity = data.identity;
            if (!companyStatus || !scrmEnable && identity !== "admin") {
              onError === null || onError === void 0 ? void 0 : onError(!companyStatus ? "\u8BE5\u8D26\u53F7\u5DF2\u505C\u7528\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\uFF01" : "\u6682\u65E0\u6743\u9650\u767B\u5F55\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\uFF01");
              redirectNoAuth && navigateToNoAuth(noAuthPage, {
                companyStatus,
                scrmEnable
              });
              return [2, false];
            }
            setUser(data, type === "pc" ? "pc" : "qw");
            return [2, true];
          }
          navigateToNoAuth(noAuthPage, {
            code,
            msg
          });
          return [2, false];
        case 3:
          error_1 = _e.sent();
          console.error(error_1);
          navigateToNoAuth(noAuthPage);
          return [2, false];
        case 4:
          return [2];
      }
    });
  });
}
function useSessionLogin(options) {
  return __awaiter(this, void 0, void 0, function() {
    var _a2, _b, whiteList, forceRequest, sessionId, checkLocalUserSid, authPage, type, sid, query, newSid, success;
    return __generator(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = options || {}, _b = _a2.whiteList, whiteList = _b === void 0 ? WhiteList : _b, forceRequest = _a2.forceRequest, sessionId = _a2.sessionId, checkLocalUserSid = _a2.checkLocalUserSid, authPage = _a2.authPage, type = _a2.type;
          if (inWhiteList(whiteList) && !forceRequest) {
            return [2, false];
          }
          sid = getUserSid(type);
          if (!sid)
            return [3, 3];
          if (!checkLocalUserSid)
            return [3, 2];
          return [4, checkSession(sid, options)];
        case 1:
          return [2, _c.sent()];
        case 2:
          return [2, true];
        case 3:
          query = getQueryString();
          newSid = sessionId || query.sessionId;
          if (!newSid)
            return [3, 5];
          setAgentConfig(query);
          return [4, checkSession(newSid, options)];
        case 4:
          success = _c.sent();
          if (!success) {
            return [2, false];
          }
          return [2, true];
        case 5:
          if (type === "pc") {
            pcNavigateToLogin(authPage);
          }
          if (type === "qw") {
            qwNavigateToLogin();
          }
          return [2, false];
      }
    });
  });
}
function useWwLoginSdk() {
  function loadWwLoginScript() {
    return new Promise(function(resolve, reject) {
      var ele = document.createElement("script");
      ele.type = "text/javascript";
      ele.async = true;
      ele.onload = function() {
        resolve(true);
      };
      ele.onerror = function(error) {
        console.error("wwlogin-sdk loaded faily!");
        console.error(error);
        reject(false);
      };
      var linkEle = document.getElementsByTagName("script")[0];
      var parentNode = linkEle.parentNode;
      parentNode.insertBefore(ele, linkEle);
      ele.src = "https://rescdn.qqmail.com/node/ww/wwopenmng/js/sso/wwLogin-1.0.0.js";
    });
  }
  return {
    loadWwLoginScript
  };
}
var noAccessPcFactory = function() {
  var interceptor = function(response) {
    var status = response.status, _a2 = response.data, data = _a2 === void 0 ? {} : _a2;
    var code = data.code;
    if (code === 4001 || status === 401) {
      setLogout("pc");
      pcNavigateToLogin();
    }
  };
  return interceptor;
};
var noAccessQw = function(response) {
  var status = response.status, _a2 = response.data, data = _a2 === void 0 ? {} : _a2;
  var code = data.code;
  if (code === 4001 || status === 401) {
    if (isDev()) {
      return;
    }
    var href = window.location.href;
    if (href.includes("sessionId=")) {
      return;
    }
    if (href.includes("/v1/auth")) {
      return;
    }
    setLogout("qw");
    qwNavigateToLogin();
  }
};
function noAccessFactory(platform, _redirectTo) {
  if (platform === "pc") {
    return noAccessPcFactory();
  }
  return noAccessQw;
}
function useNetwork(option, iqueryOptions) {
  var _a2 = option.platform, platform = _a2 === void 0 ? "pc" : _a2;
  option.redirectTo;
  var toast = option.toast, noAccessInterceptors = option.noAccessInterceptors;
  var iquery = useIQuerySdk(iqueryOptions);
  var interceptorsToast = iquery.interceptorsToast, interceptorsRequest = iquery.interceptorsRequest, interceptorsResponse = iquery.interceptorsResponse, request = iquery.request;
  if (isDev()) {
    interceptorsToast("console", {
      error: console.error.bind(console, "axios.interceptors.log")
    });
  }
  interceptorsToast("Message", {
    error: toast
  });
  interceptorsRequest("Authorization", function(config) {
    config.headers.Authorization = getUserSid(platform);
  });
  if (noAccessInterceptors) {
    interceptorsResponse("NoAccess", noAccessInterceptors);
  } else {
    interceptorsResponse("NoAccess", noAccessFactory(platform));
  }
  var check = function(value, name) {
    if (value === null || value === void 0) {
      var msg = "[ERROR PARAMS]: ".concat(name, " can't be null or undefined");
      if (isDev()) {
        throw Error(msg);
      }
    }
  };
  function factory2(method) {
    return function(url, params, extraParams) {
      var requestParams = __assign({ url, method }, extraParams);
      if (method === "GET") {
        requestParams.query = params;
      } else {
        requestParams.data = params;
      }
      return request(requestParams);
    };
  }
  var _c = [factory2("POST"), factory2("GET")], post2 = _c[0], get = _c[1];
  return __assign(__assign({}, iquery), { post: post2, get, check });
}
function useWebSocketClient(config) {
  var ws = null;
  var heartbeatInterval;
  var rawHeaderLength = 16;
  var packetOffset = 0;
  var headerOffset = 4;
  var verOffset = 6;
  var opOffset = 8;
  var seqOffset = 12;
  var MAX_CONNECT_TIMES = 100;
  var DELAY = 6e3;
  var eventBus = useEventBus();
  var platType = config.platform === "qw_manage" ? "pc" : "qw";
  function connect(max) {
    if (max === void 0) {
      max = MAX_CONNECT_TIMES;
    }
    var url = EnvManager.getSocketUrl();
    var sid = getUserSid(platType);
    if (!url || !sid) {
      console.error("websocket url or sid is null");
      return;
    }
    if (max === 0) {
      return;
    }
    if (ws) {
      ws.close();
    }
    ws = new WebSocket(url);
    ws.binaryType = "arraybuffer";
    open();
    close();
    onmessage();
  }
  function reConnect() {
    if (ws.readyState === 3) {
      connect(--MAX_CONNECT_TIMES);
      useNextTask(reConnect, DELAY);
    }
  }
  function open() {
    ws.onopen = function() {
      auth({
        mid: getUserSid(platType) || "",
        platform: config.platform
      });
    };
  }
  function close() {
    ws.onclose = function() {
      if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
      }
      useNextTask(reConnect, DELAY * 2);
    };
  }
  function onmessage() {
    ws.onmessage = function(event) {
      var data = event.data;
      var _a2 = parseData(data), packetLength = _a2.packetLength, headerLength = _a2.headerLength, op = _a2.op;
      var opMap = {
        3: operationServiceHeartbeat,
        8: operationHeartbeat,
        9: operationBatchMessage
      };
      var func = opMap[op] || operationDefault;
      func(data, packetLength, headerLength);
    };
  }
  function parseData(data) {
    var dataView = new DataView(data, 0);
    var packetLength = dataView.getInt32(packetOffset);
    var headerLength = dataView.getInt16(headerOffset);
    var ver = dataView.getInt16(verOffset);
    var op = dataView.getInt32(opOffset);
    var seq = dataView.getInt32(seqOffset);
    return {
      packetLength,
      headerLength,
      ver,
      op,
      seq
    };
  }
  function operationHeartbeat() {
    heartbeat();
    if (heartbeatInterval) {
      clearInterval(heartbeatInterval);
    }
    heartbeatInterval = setInterval(function() {
      heartbeat();
    }, 30 * 1e3);
  }
  function operationDefault(data, headerLength, packetLength) {
    var textDecoder = new TextDecoder();
    var message = textDecoder.decode(data.slice(headerLength, packetLength));
    eventBus.dispatch(EventKeys.WebSocket, message);
  }
  function operationServiceHeartbeat() {
    console.log("service heartbeat");
  }
  function operationBatchMessage(data, packetLength) {
    var dataView = new DataView(data, 0);
    for (var offset = rawHeaderLength; offset < data.byteLength; offset += packetLength) {
      var packetLen = dataView.getInt32(offset);
      var headerLen = dataView.getInt16(offset + headerOffset);
      operationDefault(data, offset + headerLen, offset + packetLen);
    }
  }
  function heartbeat() {
    var headerBuffer = new ArrayBuffer(rawHeaderLength);
    var headerView = new DataView(headerBuffer, 0);
    headerView.setInt32(packetOffset, rawHeaderLength);
    headerView.setInt16(headerOffset, rawHeaderLength);
    headerView.setInt16(verOffset, 1);
    headerView.setInt32(opOffset, 2);
    headerView.setInt32(seqOffset, 1);
    ws.send(headerBuffer);
  }
  function auth(auth2) {
    var textEncoder = new TextEncoder();
    var headerBuffer = new ArrayBuffer(rawHeaderLength);
    var headerView = new DataView(headerBuffer, 0);
    var bodyBuffer = textEncoder.encode(JSON.stringify(auth2));
    headerView.setInt32(packetOffset, rawHeaderLength + bodyBuffer.byteLength);
    headerView.setInt16(headerOffset, rawHeaderLength);
    headerView.setInt16(verOffset, 1);
    headerView.setInt32(opOffset, 7);
    headerView.setInt32(seqOffset, 1);
    ws.send(mergeArrayBuffer(headerBuffer, bodyBuffer));
  }
  function mergeArrayBuffer(headerBuffer, bodyBuffer) {
    var headerUnit8Array = new Uint8Array(headerBuffer);
    var bodyUnit8Array = new Uint8Array(bodyBuffer);
    var response = new Uint8Array(headerUnit8Array.byteLength + bodyUnit8Array.byteLength);
    response.set(headerUnit8Array, 0);
    response.set(bodyUnit8Array, headerUnit8Array.byteLength);
    return response.buffer;
  }
  function destroy() {
    if (ws) {
      ws.onclose = null;
      ws.close();
    }
    ws = null;
  }
  return __assign(__assign({}, eventBus), { connect, destroy });
}
function useGlobalWebsocket(config) {
  if (window.__ITIMO_WEB_SOCKET) {
    return window.__ITIMO_WEB_SOCKET;
  }
  window.__ITIMO_WEB_SOCKET = useWebSocketClient(config);
  window.__ITIMO_WEB_SOCKET.connect();
  return window.__ITIMO_WEB_SOCKET;
}
function parseJSON(json) {
  if (!json) {
    return void 0;
  }
  try {
    return JSON.parse(json);
  } catch (error) {
    return void 0;
  }
}
function useNoticeObserver(observer) {
  var onNotice = function(_a2) {
    var detail = _a2.detail;
    if (!detail) {
      return;
    }
    var data = parseJSON(detail);
    if (!data) {
      console.error("parse notice message error");
      return;
    }
    observer(data);
  };
  EventBus.on(EventKeys.WebSocket, onNotice);
  return function() {
    EventBus.off(EventKeys.WebSocket, onNotice);
  };
}
function change(domain, path, options, replace2) {
  if (replace2 === void 0) {
    replace2 = false;
  }
  var toUrl = path ? "/scrm-manage/".concat(domain, "/#/").concat(path) : "/scrm-manage/".concat(domain);
  return window.history[replace2 ? "replaceState" : "pushState"]((options === null || options === void 0 ? void 0 : options.state) || null, (options === null || options === void 0 ? void 0 : options.title) || "", toUrl);
}
function push(domain, path, options) {
  change(domain, path, options);
}
function replace(domain, path, options) {
  change(domain, path, options, true);
}
var HistoryUtils = {
  push,
  replace
};
var MicroAppReload;
(function(MicroAppReload2) {
  function emit() {
    var eventBus = useEventBus();
    eventBus.dispatch(EventKeys.ReloadMicroPage);
  }
  MicroAppReload2.emit = emit;
  function on(cb) {
    var eventBus = useEventBus();
    eventBus.on(EventKeys.ReloadMicroPage, cb);
  }
  MicroAppReload2.on = on;
  function off(cb) {
    var eventBus = useEventBus();
    eventBus.off(EventKeys.ReloadMicroPage, cb);
  }
  MicroAppReload2.off = off;
})(MicroAppReload || (MicroAppReload = {}));
function useTest(sid) {
  return __awaiter(this, void 0, void 0, function() {
    var network, success, accessData, error_1;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!isDev()) {
            return [2];
          }
          setUserSid(sid);
          network = useNetwork({
            platform: "pc",
            toast: function(message) {
              console.log("====error====", message);
            }
          }, {
            baseURL: EnvManager.getBaseUrl()
          });
          _a2.label = 1;
        case 1:
          _a2.trys.push([1, 3, , 4]);
          return [4, CoreSdk.initSdk({ useNetwork: network })];
        case 2:
          success = _a2.sent();
          console.log("====initSdk====", success);
          if (success) {
            accessData = CoreSdk.dataManager.accessData();
            console.log("===access data ====", accessData);
          }
          return [3, 4];
        case 3:
          error_1 = _a2.sent();
          console.log("init sdk error", error_1);
          return [3, 4];
        case 4:
          return [2];
      }
    });
  });
}
function useDebugger() {
  function log() {
    useDataBus().log();
    GlobalState.log();
  }
  return { log };
}
function useITimoLogger() {
  if (!window.__ITIMO_LOGGER) {
    window.__ITIMO_LOGGER = useDebugger();
  }
  return window.__ITIMO_LOGGER;
}
export { AccountType, CookieKeys, CookieStorage, CoreSdk, DataKeys, DraftTitleName, DraftType, EnvManager, EventBus, EventKeys, GlobalComponentClient, GlobalComponentServer, GlobalState, HistoryUtils, IndexDB, LegacyLocalStorage, MicroAppManager, MicroAppReload, RouterUtils, SessionCookieKeys, Storage, createStorageFactory, getAgentConfig, getDataFunc, getMenuList, getQueryString, getTenantType, getUser, getUserSid, hasSwitchConfig, isDev, isHasFunc, isInQianKun, isProvidedUpgraded, pcNavigateToLogin, qwNavigateToLogin, setAgentConfig, setLogout, setUser, setUserSid, useAccess, useAccessLoader, useAppConfig, useAppVersion, useAxiosNetwork, useDataBus, useDataManage, useDraftBox, useEventBus, useGlobalWebsocket, useITimoLogger, useNetwork, useNextTask, useNoticeObserver, useOEM, usePresetGlobalComponents, useSessionLogin, useSwitchConfig, useTenantType, useTest, useWebSocketClient, useWwLoginSdk };
